function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCartError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 420.09,
    y: 272.08,
    width: 48.65,
    height: 12.87,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.86,298.09a1,1,0,0,1,0-.23v-.66c0-.61,0-1.45,0-2.54,0-2.22-.05-5.41-.08-9.44l.15.15-48.65.1c.11-.11-.25.25.24-.25h0v12.85l-.25-.24,34.68.11,10.23.07,2.77,0,.72,0h.26a.94.94,0,0,1-.23,0h-.69l-2.72,0-10.17.06-34.85.11H401v-13.1h0l.25-.25,48.65.1H450v.15c0,4.07-.07,7.29-.09,9.53,0,1.07,0,1.91,0,2.5,0,.26,0,.47,0,.64A1.23,1.23,0,0,1,449.86,298.09Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 137.93,
    y: 177.23,
    width: 48.65,
    height: 12.87,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.7,203.24a2.07,2.07,0,0,1,0-.23l0-.66c0-.61,0-1.45,0-2.53,0-2.23,0-5.42-.08-9.45l.15.15-48.65.1.25-.25h0v6.53q0,3.22,0,6.33l-.24-.24,34.67.11,10.23.07,2.77,0,.73,0h.25s-.07,0-.22,0h-.7l-2.71,0-10.18.07-34.84.11h-.24v-.25c0-2.07,0-4.18,0-6.33v-6.53h0l.25-.25,48.65.1h.15v.15c0,4.07-.06,7.29-.08,9.54,0,1.06,0,1.9,0,2.5,0,.26,0,.46,0,.63S167.71,203.25,167.7,203.24Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416.7,
    y: 68.8,
    width: 48.65,
    height: 12.87,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 310.88,
    y: 96.79,
    width: 48.65,
    height: 12.87,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178.72,
    y: 361.08,
    width: 48.65,
    height: 12.87,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.47,94.81a1,1,0,0,1,0-.23v-.66c0-.61,0-1.45,0-2.54,0-2.22,0-5.41-.08-9.44l.15.15-48.65.1c.11-.11-.25.24.24-.25h0V94.81l-.24-.24,34.67.11,10.23.07,2.77,0,.72,0h.26l-.23,0h-.69l-2.71,0-10.18.07-34.84.11h-.25V82h0l.25-.25,48.65.1h.15v.15c0,4.07-.06,7.29-.08,9.53,0,1.07,0,1.9,0,2.5,0,.26,0,.47,0,.64A1.23,1.23,0,0,1,446.47,94.81Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46.48,
    y: 281.8,
    width: 48.65,
    height: 12.87,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.25,307.81a1,1,0,0,1,0-.23v-.66c0-.61,0-1.45,0-2.53,0-2.22-.05-5.42-.08-9.45l.15.15-48.65.1c.11-.11-.25.25.24-.25h0v12.86l-.24-.24,34.67.11,10.23.07,2.77,0,.72,0h.26s-.07,0-.23,0l-.69,0-2.72,0L62.44,308l-34.84.11h-.25V295h0c.49-.49.14-.13.25-.24l48.65.09h.15v.15c0,4.07-.07,7.29-.08,9.54,0,1.07,0,1.9,0,2.5,0,.26,0,.46,0,.63A1.23,1.23,0,0,1,76.25,307.81Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.15,67.53a1,1,0,0,1,0-.23v-.66c0-.61,0-1.45,0-2.53,0-2.22-.05-5.42-.08-9.45l.15.15-48.65.1c.11-.11-.25.25.24-.25h0V67.53l-.24-.24,34.67.11,10.23.07,2.77,0,.72,0h.26a.94.94,0,0,1-.23,0l-.69,0-2.72,0-10.17.07-34.84.11h-.25V54.67h0c.49-.49.14-.13.25-.24l48.65.09h.15v.15c0,4.07-.06,7.29-.08,9.54,0,1.07,0,1.9,0,2.5l0,.63A1.23,1.23,0,0,1,299.15,67.53Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.75,54.66a.68.68,0,0,1,0-.24c0-.19,0-.41,0-.68,0-.64,0-1.5,0-2.58,0-2.26-.05-5.45-.09-9.37l.18.18L276.52,42c-.23.22.29-.3.24-.25h0v6.62c0,2.16,0,4.24,0,6.24l-.24-.23,20.91.11,6.1.06,1.64,0,.59,0a3.43,3.43,0,0,1-.53,0l-1.6,0-6,.07-21.07.11h-.23v-.24q0-3,0-6.24V41.8h0l.25-.25,29.23.07h.18v.18c0,4-.07,7.19-.09,9.47,0,1.07,0,1.92-.05,2.54A8.58,8.58,0,0,1,305.75,54.66Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.3,312.39a2.07,2.07,0,0,1,0-.23c0-.18,0-.39,0-.66,0-.61,0-1.45,0-2.54,0-2.22-.05-5.41-.09-9.44l.15.15-48.65.1.25-.25h0v6.52q0,3.22,0,6.33l-.24-.24,34.67.11,10.24.07,2.76,0h.73l.25,0s-.07,0-.22,0h-.7l-2.71,0-10.18.07-34.84.11h-.24v-.24q0-3.11,0-6.33v-6.52h0l.25-.25,48.65.1h.16v.15c0,4.07-.06,7.29-.08,9.53,0,1.07,0,1.9,0,2.5l0,.64C258.31,312.33,258.31,312.4,258.3,312.39Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.9,299.52a1.41,1.41,0,0,1,0-.25c0-.18,0-.4,0-.68,0-.63,0-1.49,0-2.58,0-2.26-.06-5.44-.1-9.36l.18.18-29.23.07.25-.25h0V290c0,1.11,0,2.2,0,3.28,0,2.15,0,4.24,0,6.24l-.23-.24,20.91.12,6.09.06,1.64,0,.59,0a3.28,3.28,0,0,1-.53,0l-1.59,0-6,.06-21.07.12h-.24v-.24c0-2,0-4.09,0-6.24v-6.61h0l.25-.25,29.23.07h.18v.18c0,4-.07,7.19-.1,9.47,0,1.07,0,1.92,0,2.54A6.65,6.65,0,0,1,264.9,299.52Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.84,77.33s0-.09,0-.24l0-.66c0-.6,0-1.45,0-2.53,0-2.22,0-5.42-.08-9.44l.15.15-48.65.09.25-.24h0V71c0,2.14,0,4.26,0,6.33l-.24-.25,34.67.11,10.23.07,2.77,0h.73a1.27,1.27,0,0,1,.25,0h-.22l-.7,0-2.71,0L70,77.46l-34.84.11H35v-.24c0-2.07,0-4.19,0-6.33V64.48h0l.25-.25,48.65.1H84v.15c0,4.06-.06,7.29-.08,9.53,0,1.07,0,1.9,0,2.5v.63A.85.85,0,0,1,83.84,77.33Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.44,64.46a1.41,1.41,0,0,1,0-.25c0-.18,0-.41,0-.68,0-.63,0-1.5,0-2.58,0-2.26-.06-5.45-.1-9.37l.18.18-29.23.07.24-.24h0v6.61c0,2.15,0,4.24,0,6.24l-.23-.24,20.91.11,6.09.07,1.64,0,.59,0a2.86,2.86,0,0,1-.53,0l-1.6,0-6,.07-21.07.11H61v-.23c0-2,0-4.09,0-6.24V51.61h0c-.06,0,.47-.47.25-.25l29.23.07h.18v.17c0,4-.08,7.19-.1,9.48,0,1.07,0,1.91,0,2.54S90.45,64.47,90.44,64.46Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M475.89,463.12c0,.14-101.66.26-227,.26s-227-.12-227-.26,101.63-.26,227.05-.26S475.89,463,475.89,463.12Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Bag--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M444.41,355.78A20.85,20.85,0,0,0,427.48,341a16.48,16.48,0,0,0-7.45.56,22.8,22.8,0,0,0-13.26,11.34c-1.1,1.84.91,23.55.91,23.55l7.15-1.5s-4.07-26.14-3.54-26.39,4-5,10.3-5.11,11.64,2.8,13.16,6.47,5.48,19.71,5.48,19.71l8.2-1.42Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.41,355.78a.75.75,0,0,1,.09.2l.22.62.81,2.4c.7,2.13,1.73,5.22,3,9.17l.05.15-.16,0-8.19,1.45-.16,0,0-.15c-1-3.84-2.09-8.16-3.4-12.87-.34-1.17-.69-2.37-1-3.59a29.71,29.71,0,0,0-1.29-3.64,11.14,11.14,0,0,0-6.2-4.84,17.4,17.4,0,0,0-8.47-.83,14.41,14.41,0,0,0-7.71,4.41,5.49,5.49,0,0,1-.48.43l-.05,0s-.06,0,0,0,.05-.08.06-.08,0,.06,0,.1v.28c0,.38.05.77.09,1.16.09.78.18,1.57.26,2.36.21,1.58.42,3.18.64,4.78.46,3.21.93,6.48,1.41,9.79.4,2.61.79,5.2,1.18,7.75l0,.24-.24.05-7.14,1.51-.29.05,0-.28c-.46-5.16-.84-10.17-1.08-15-.1-2.41-.21-4.77-.09-7.1,0-.29.05-.58.1-.88,0-.14.06-.3.09-.44a2.61,2.61,0,0,1,.21-.44c.29-.49.57-1,.87-1.47a25.85,25.85,0,0,1,2-2.73,22.13,22.13,0,0,1,10.2-6.95,17.48,17.48,0,0,1,10.64,0,22,22,0,0,1,4.29,1.81,23,23,0,0,1,3.38,2.4,21.21,21.21,0,0,1,4.23,5,22,22,0,0,1,1.78,3.73c.13.43.24.77.32,1a1.61,1.61,0,0,1,.09.35s-.05-.11-.13-.33-.22-.58-.37-1a22.63,22.63,0,0,0-1.85-3.66,21.1,21.1,0,0,0-4.24-4.93,21.82,21.82,0,0,0-3.36-2.33,21.4,21.4,0,0,0-4.24-1.76,17.22,17.22,0,0,0-10.41.09,21.89,21.89,0,0,0-10,6.87,24.05,24.05,0,0,0-1.91,2.69c-.29.47-.57,1-.86,1.46a3.57,3.57,0,0,0-.33,1.55c-.11,2.28,0,4.65.11,7.05.24,4.81.64,9.81,1.1,15l-.31-.23,7.14-1.51-.2.3c-.39-2.55-.78-5.14-1.18-7.75-.48-3.32-.95-6.58-1.42-9.8-.21-1.61-.42-3.2-.63-4.79-.08-.79-.17-1.58-.26-2.37,0-.4-.07-.79-.09-1.19v-.32c0-.06,0-.1,0-.19s0-.06.12-.21l.07-.05h0c.09-.07.26-.24.39-.36a14.82,14.82,0,0,1,8-4.53,17.63,17.63,0,0,1,8.72.87,14.2,14.2,0,0,1,3.73,2,8.88,8.88,0,0,1,2.7,3.09,28.39,28.39,0,0,1,1.31,3.71c.36,1.23.71,2.43,1,3.61,1.29,4.72,2.38,9.05,3.32,12.9l-.19-.13,8.21-1.38-.11.17c-1.25-4-2.23-7.07-2.91-9.21-.32-1-.57-1.85-.74-2.42-.08-.26-.14-.47-.19-.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.74,352.86a5.8,5.8,0,0,1,1.85-2.54,5.88,5.88,0,0,1,2.67-1.67A25,25,0,0,1,409,350.7,27.71,27.71,0,0,1,406.74,352.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.11,355.22a63.74,63.74,0,0,0-5.93-5.6,65.82,65.82,0,0,0-6.9-4.34,8.52,8.52,0,0,1,2.25.86,27.81,27.81,0,0,1,9.18,7.1A8.45,8.45,0,0,1,442.11,355.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.2,368.36c0,.62,2.79,36.7.74,52.76s11.41,8,6.29,39.25c-.69,4.15-87.34,2.21-87.73,2.31s.74-80.53,1.46-80.92c.49-.26,36.82-13,60.12-13.21C458.1,368.43,466.2,368.36,466.2,368.36Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.2,368.36l-.9,0-2.62.05-10,.16a128.87,128.87,0,0,0-15.77.86,188.68,188.68,0,0,0-20.6,3.91c-7.55,1.82-15.76,4.12-24.45,6.95l-3.27,1.1-.82.29-.4.15-.2.07-.09,0c.06,0,.09-.11.08-.07v0a15.5,15.5,0,0,0-.15,1.72c-.13,2.35-.2,4.75-.28,7.19q-.16,7.31-.35,15c-.2,10.27-.37,21.07-.51,32.25q-.08,8.4-.16,17.07v4.34l0,2.19v.54l0,.26v.1c0-.06-.48-.27-.21-.18h1.18l8.85.13c11.86.16,23.45.26,34.64.24s22-.14,32.24-.74c2.56-.17,5.1-.36,7.56-.74a17.39,17.39,0,0,0,1.8-.38,5.56,5.56,0,0,0,.84-.3,1.29,1.29,0,0,0,.3-.21.27.27,0,0,0,.06-.09l0-.23q.25-1.83.51-3.63a50,50,0,0,0,.19-14.06c-.1-.56-.2-1.11-.31-1.66l-.48-1.6a10.79,10.79,0,0,0-.6-1.55,11.82,11.82,0,0,0-.73-1.47c-1-1.92-2.48-3.56-3.51-5.45a12.33,12.33,0,0,1-1.53-6.07,54.39,54.39,0,0,1,.44-6c.64-7.74.53-14.79.44-21s-.35-11.49-.56-15.83-.41-7.7-.53-10c-.06-1.14-.1-2-.14-2.61,0-.29,0-.51,0-.65v-.23s.41,4.79.9,13.48c.23,4.34.49,9.66.64,15.83a205.8,205.8,0,0,1-.36,21,52.54,52.54,0,0,0-.42,5.93c0,.5,0,1,.07,1.51s.19,1,.29,1.5a11.21,11.21,0,0,0,1.13,2.87c1,1.84,2.45,3.49,3.52,5.45a10,10,0,0,1,.75,1.5,10.15,10.15,0,0,1,.62,1.58c.16.54.33,1.09.5,1.64s.21,1.12.31,1.69a50,50,0,0,1-.16,14.18c-.17,1.21-.33,2.43-.5,3.66l0,.23a.58.58,0,0,1-.16.31,1.41,1.41,0,0,1-.44.32,5.71,5.71,0,0,1-.92.34,16.59,16.59,0,0,1-1.86.39c-2.49.4-5,.59-7.6.76-10.27.61-21.08.71-32.27.77s-22.78-.07-34.65-.23l-8.84-.13h-1.16c.22,0-.31-.17-.31-.22a.65.65,0,0,1,0-.18l0-.28v-.55l0-2.19c0-1.46,0-2.91,0-4.36.05-5.77.11-11.47.16-17.06.14-11.19.32-22,.54-32.26.13-5.14.25-10.16.37-15,.08-2.43.16-4.83.29-7.2a16.13,16.13,0,0,1,.17-1.79.31.31,0,0,1,0-.08.35.35,0,0,1,.13-.17l.11,0,.22-.08.42-.15.83-.29,3.28-1.1c8.71-2.82,16.92-5.1,24.5-6.9a187.75,187.75,0,0,1,20.64-3.84,125.91,125.91,0,0,1,15.86-.77l10,0h3.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.49,407.68a3.78,3.78,0,0,1,.72.19l2,.64c1.75.57,4.28,1.38,7.42,2.34,6.28,1.93,15,4.39,24.74,6.79s18.59,4.38,25,5.82l7.59,1.73,2.06.49a5.61,5.61,0,0,1,.71.2,3.11,3.11,0,0,1-.73-.1l-2.08-.4-7.62-1.56c-6.43-1.35-15.31-3.27-25.05-5.67s-18.47-4.92-24.73-6.95c-3.13-1-5.65-1.86-7.37-2.5l-2-.73A3.28,3.28,0,0,1,392.49,407.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386,387.44a6.59,6.59,0,0,1,.82-.07l2.36-.1,1.71-.07,2-.2,2.32-.23c.82-.1,1.68-.26,2.59-.39a105.53,105.53,0,0,0,12.54-2.85c4.68-1.29,9.76-2.92,15.17-4.42A150.65,150.65,0,0,1,441,375.68a125.17,125.17,0,0,1,12.85-1.31l4.95-.17,3.75.08,2.36.07a4.54,4.54,0,0,1,.83.06,4.89,4.89,0,0,1-.83,0l-2.36,0h-3.74l-4.94.25c-3.66.2-8,.67-12.8,1.41s-10,2-15.38,3.46-10.48,3.11-15.17,4.38a98.53,98.53,0,0,1-12.62,2.75c-.91.13-1.77.27-2.6.36l-2.33.19-2,.16-1.71,0h-2.37A4.7,4.7,0,0,1,386,387.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.41,374.85a11.27,11.27,0,0,1-.78-3.28,10.81,10.81,0,0,1-.27-3.36,22,22,0,0,1,1.05,6.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.79,376a14.2,14.2,0,0,1-.71-3.65,13.15,13.15,0,0,1-.19-3.67,26.35,26.35,0,0,1,.9,7.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.89,368.63a4.74,4.74,0,0,1,1.5.74c.88.53,2,1.33,3.3,2.24s2.42,1.7,3.28,2.23a7,7,0,0,1,1.38.92,4.25,4.25,0,0,1-1.56-.6,27.2,27.2,0,0,1-3.4-2.13c-1.27-.91-2.39-1.76-3.21-2.36A6.43,6.43,0,0,1,439.89,368.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.79,376a13.83,13.83,0,0,1,3.4-4.16,29.93,29.93,0,0,1,4.11-3.43,26.32,26.32,0,0,1-3.76,3.81C442.37,374.16,440.91,376,440.79,376Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.92,381.9a38.53,38.53,0,0,1-2.23-8.71,19.54,19.54,0,0,1,1.37,4.29A19.12,19.12,0,0,1,416.92,381.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.23,383.79a19.94,19.94,0,0,1-1.5-4.22,19.16,19.16,0,0,1-1-4.37,37.8,37.8,0,0,1,2.51,8.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408,375.26a38.83,38.83,0,0,1,4.54,3.09,38.13,38.13,0,0,1,4.39,3.29,38.12,38.12,0,0,1-8.93-6.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.23,383.79c-.1-.06.91-2.41,2.07-5.36s2.2-5.32,2.39-5.24a9.22,9.22,0,0,1-.48,1.62c-.34,1-.83,2.34-1.43,3.81C411.62,381.58,410.38,383.87,410.23,383.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.83,433.94c-1.28,1.09-11.05,11.19-19.51,11.14s-18.21-9.62-18.21-9.62Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.67,396.65s-2.36,35.17-3.84,37.29-16.72,8.83-19.47,9.12-18.09-6.83-18.25-7.6-6.69-38.11-6.69-38.11Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.13,403.31c-.08,0-.12-.29-.14-.75v-.79l0-.47v-.49h0l.26.28h0a6,6,0,0,1-2.5-.23,6.35,6.35,0,0,1,2.49-.29h0l.26.28h0v.24l0,.25c0,.14,0,.3,0,.46s-.07.57-.11.79C446.28,403,446.2,403.31,446.13,403.31Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.33,413.61a6.81,6.81,0,0,1-.05-2.59,6.69,6.69,0,0,1,.46-2.56,12.67,12.67,0,0,1-.41,5.15Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.36,423.91a6.35,6.35,0,0,1,0-2.6,6.54,6.54,0,0,1,.52-2.54,12.88,12.88,0,0,1-.52,5.14Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440,432.39c-.07-.13.92-.75,2.09-1.52a7.53,7.53,0,0,0,.78-.57,1.39,1.39,0,0,0,.24-.26c.05-.1.1-.22.14-.32.17-.42.28-.7.36-.69s.08.31,0,.79a2.73,2.73,0,0,1-.11.4,1.5,1.5,0,0,1-.3.43,5.33,5.33,0,0,1-.82.65A5.41,5.41,0,0,1,440,432.39Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.6,436.62a7,7,0,0,1,2.29-1.23,6.86,6.86,0,0,1,2.49-.75,13,13,0,0,1-4.78,2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.78,435.11a12.86,12.86,0,0,1,4.83,1.85,6.35,6.35,0,0,1-2.5-.68A6.54,6.54,0,0,1,420.78,435.11Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.13,429.3c.07,0,.19.26.32.71.06.23.13.5.2.8l.1.47s0,.14,0,.07,0,0,0,0l.18.14c1.18.73,2.2,1.32,2.12,1.45a5.28,5.28,0,0,1-2.41-1l-.24-.18a.75.75,0,0,1-.14-.19.43.43,0,0,1,0-.18l-.07-.48a7,7,0,0,1-.09-.82C413.05,429.61,413.06,429.31,413.13,429.3Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.34,419.11a6.56,6.56,0,0,1,.71,2.51,6.83,6.83,0,0,1,.19,2.59,6.76,6.76,0,0,1-.71-2.5A6.88,6.88,0,0,1,411.34,419.11Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.56,408.93a6.49,6.49,0,0,1,.7,2.5,6.59,6.59,0,0,1,.19,2.59,6.7,6.7,0,0,1-.7-2.5A6.59,6.59,0,0,1,409.56,408.93Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.74,401.33a6.42,6.42,0,0,1-2.5.29h0l.25-.3h0v.11l0,.13,0,.24.07.47c0,.3.07.56.08.79,0,.45,0,.74-.05.75s-.19-.25-.31-.69c-.06-.21-.13-.48-.19-.77l-.1-.46-.05-.24,0-.13v-.11h0l.25-.31h0A6.11,6.11,0,0,1,410.74,401.33Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.18,401.19a5.44,5.44,0,0,1-2.36.3,5.57,5.57,0,0,1-2.36-.23,11.05,11.05,0,0,1,4.72-.07Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.63,401.06a5.72,5.72,0,0,1-2.36.29,5.39,5.39,0,0,1-2.36-.23,5.65,5.65,0,0,1,2.35-.29A5.42,5.42,0,0,1,429.63,401.06Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.08,400.92a5.48,5.48,0,0,1-2.36.3,5.83,5.83,0,0,1-2.37-.23,5.66,5.66,0,0,1,2.36-.3A5.83,5.83,0,0,1,439.08,400.92Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.52,414c.07-.13,6,2.76,13.28,6.46s13.11,6.8,13,6.93-6-2.76-13.28-6.46S415.46,414.12,415.52,414Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Pallet--inject-2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 140.77,
    y: 225.87,
    width: 28.61,
    height: 195.14,
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 191.8,
    y: 225.87,
    width: 28.61,
    height: 195.14,
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 245.59,
    y: 225.87,
    width: 28.61,
    height: 195.14,
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 298.87,
    y: 225.87,
    width: 28.61,
    height: 195.14,
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 350.58,
    y: 225.87,
    width: 28.61,
    height: 195.14,
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 152.89,
    y: 389.98,
    width: 210.44,
    height: 22.87,
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 152.89,
    y: 239.06,
    width: 210.44,
    height: 22.87,
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 152.89,
    y: 317.54,
    width: 210.44,
    height: 22.87,
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.47,417c-.15,0-.27-42.79-.27-95.55s.12-95.56.27-95.56.26,42.77.26,95.56S169.61,417,169.47,417Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.8,417c-.15,0-.26-42.79-.26-95.55s.11-95.56.26-95.56.26,42.77.26,95.56S191.94,417,191.8,417Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.41,417c-.14,0-.26-42.79-.26-95.55s.12-95.56.26-95.56.26,42.77.26,95.56S220.55,417,220.41,417Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.59,417c-.14,0-.26-42.79-.26-95.55s.12-95.56.26-95.56.26,42.77.26,95.56S245.73,417,245.59,417Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.2,417c-.14,0-.26-42.79-.26-95.55s.12-95.56.26-95.56.26,42.77.26,95.56S274.35,417,274.2,417Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.87,417c-.14,0-.26-42.79-.26-95.55s.12-95.56.26-95.56.26,42.77.26,95.56S299,417,298.87,417Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328,417c-.15,0-.26-42.79-.26-95.55s.11-95.56.26-95.56.26,42.77.26,95.56S328.14,417,328,417Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.58,417c-.14,0-.26-42.79-.26-95.55s.12-95.56.26-95.56.26,42.77.26,95.56S350.72,417,350.58,417Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.19,417c-.14,0-.26-42.79-.26-95.55s.12-95.56.26-95.56.26,42.77.26,95.56S379.34,417,379.19,417Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 154.95,
    cy: 249.39,
    r: 2.06,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.16,249.39a2.06,2.06,0,1,1-2.06-2.06A2.06,2.06,0,0,1,208.16,249.39Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 260.17,
    cy: 249.39,
    r: 2.06,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.29,249.39a2.06,2.06,0,1,1-2.06-2.06A2.06,2.06,0,0,1,316.29,249.39Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 368.29,
    cy: 249.39,
    r: 2.06,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 154.95,
    cy: 401.41,
    r: 2.06,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.16,401.41a2.06,2.06,0,1,1-2.06-2.06A2.06,2.06,0,0,1,208.16,401.41Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 260.17,
    cy: 401.41,
    r: 2.06,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.29,401.41a2.06,2.06,0,1,1-2.06-2.06A2.06,2.06,0,0,1,316.29,401.41Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 368.29,
    cy: 401.41,
    r: 2.06,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136.33,
    y: 456.41,
    width: 249.09,
    height: 6.63,
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136.52,
    y: 434.43,
    width: 23.15,
    height: 21.99,
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 249.3,
    y: 434.43,
    width: 23.15,
    height: 21.99,
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 362.27,
    y: 434.43,
    width: 23.15,
    height: 21.99,
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136.33,
    y: 428.81,
    width: 249.09,
    height: 6.63,
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136.33,
    y: 424.17,
    width: 29.92,
    height: 4.64,
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 189.68,
    y: 424.17,
    width: 29.92,
    height: 4.64,
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 245.92,
    y: 424.17,
    width: 29.92,
    height: 4.64,
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 301.63,
    y: 424.17,
    width: 29.92,
    height: 4.64,
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 355.69,
    y: 424.17,
    width: 29.92,
    height: 4.64,
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384,428.81c0,.14-55.44.26-123.82.26s-123.83-.12-123.83-.26,55.43-.26,123.83-.26S384,428.66,384,428.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384,435.3c0,.15-55.44.26-123.82.26s-123.83-.11-123.83-.26,55.43-.26,123.83-.26S384,435.16,384,435.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384,456.9c0,.14-55.44.26-123.82.26s-123.83-.12-123.83-.26,55.43-.26,123.83-.26S384,456.76,384,456.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 123.6,
    y: 402.89,
    width: 269.58,
    height: 21.28,
    rx: 8.56,
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.87,402.89l.74,0,2.25,0v.11c-12.28.12-63.36.21-124.48.21l-90.15-.08L144.92,403l-7.43-.05-1.93,0-.66,0,.66,0,1.93,0,7.43-.05,27.31-.08,90.15-.07c61.12,0,112.2.08,124.48.2v.11l-2.25,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.92,405.58H270.14a7.71,7.71,0,0,1-7.72-7.72h0a7.72,7.72,0,0,1,7.72-7.72h92.78a7.72,7.72,0,0,1,7.72,7.72h0A7.72,7.72,0,0,1,362.92,405.58Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.92,390.27H270.14a7.72,7.72,0,0,1-7.72-7.72h0a7.72,7.72,0,0,1,7.72-7.72h92.78a7.72,7.72,0,0,1,7.72,7.72h0A7.72,7.72,0,0,1,362.92,390.27Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.87,390.21c0,.14-20.27.26-45.26.26s-45.27-.12-45.27-.26,20.26-.26,45.27-.26S358.87,390.06,358.87,390.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.57,398.79c0,.14-21.31.26-47.59.26s-47.6-.12-47.6-.26,21.31-.26,47.6-.26S369.57,398.65,369.57,398.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.57,382.49c0,.14-21.31.26-47.59.26s-47.6-.12-47.6-.26,21.31-.26,47.6-.26S369.57,382.34,369.57,382.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.16,376.4H294.58a7.72,7.72,0,0,1-7.72-7.72h0a7.72,7.72,0,0,1,7.72-7.72h59.58a7.72,7.72,0,0,1,7.72,7.72h0A7.72,7.72,0,0,1,354.16,376.4Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.16,361.08H294.58a7.72,7.72,0,0,1-7.72-7.72h0a7.72,7.72,0,0,1,7.72-7.72h59.58a7.72,7.72,0,0,1,7.72,7.72h0A7.71,7.71,0,0,1,354.16,361.08Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.73,361.08c0,.15-14.05.27-31.38.27s-31.38-.12-31.38-.27,14-.26,31.38-.26S353.73,360.94,353.73,361.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.15,369.67c0,.14-14.78.26-33,.26s-33-.12-33-.26,14.78-.26,33-.26S361.15,369.52,361.15,369.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.15,353.36c0,.15-14.78.26-33,.26s-33-.11-33-.26,14.78-.26,33-.26S361.15,353.22,361.15,353.36Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--plant-5--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M463.57,193.64l-44.26-.28-.19,17.82a10.31,10.31,0,0,0,.32,2.71l-.15,12.51a22.66,22.66,0,0,0,.7,6c.95,3.62,3.09,8.14,7.9,8.14h3.28a3.19,3.19,0,0,0,2.51-1.23l.76-1a1,1,0,0,1,1.65.25,3.18,3.18,0,0,0,3,2.09l7.63-.11a1.88,1.88,0,0,0,1.69-1.33,1,1,0,0,1,1.7-.2l.43.68a2,2,0,0,0,1.65.89h3.69a6.46,6.46,0,0,0,5.67-3.33l.06-.12a18.91,18.91,0,0,0,2.08-7.84v-14a2.49,2.49,0,0,1-.16-3.07Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.31,191.89V173.27H421v19l-.08.07a3.92,3.92,0,0,0-1.13,2.74v3.06a7.15,7.15,0,0,0,2.06,5l11.92,12.11v4.39h-.26a.79.79,0,0,0-.78.62.76.76,0,0,0,.74.88h.3v3.62l16.19-.1V221.2h.33a.78.78,0,0,0,.77-.62.75.75,0,0,0-.73-.88H450v-4.25l11.66-13a7.13,7.13,0,0,0,1.83-4.77v-3A3.85,3.85,0,0,0,462.31,191.89Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.64,193.08V181.87l-33.86.17v11.39l0,0a3.18,3.18,0,0,0-.93,2.25v2.51a5.85,5.85,0,0,0,1.68,4.11l10.07,11.18v6.26H448.6v-6.15l9.48-11.91a5.89,5.89,0,0,0,1.49-3.92v-2.49A3.14,3.14,0,0,0,458.64,193.08Z",
    style: {
      fill: "#6f4439"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421,192.09c0-.05,9.22-.09,20.6-.09s20.6,0,20.6.09-9.22.1-20.6.1S421,192.15,421,192.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.73,221.28c0-.05,3.63-.11,8.11-.13s8.12,0,8.12,0-3.63.11-8.12.13S433.73,221.33,433.73,221.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.31,219.7s3.72-.09,8.31-.09,8.3,0,8.3.09-3.72.09-8.3.09S433.31,219.75,433.31,219.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.77,218.41s3.62-.09,8.08-.09,8.07,0,8.07.09-3.61.1-8.07.1S433.77,218.46,433.77,218.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.77,217.13s3.62-.1,8.08-.1,8.07.05,8.07.1-3.61.09-8.07.09S433.77,217.18,433.77,217.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.31,191.89a2.07,2.07,0,0,1,.35.36,3.74,3.74,0,0,1,.7,1.32,9.2,9.2,0,0,1,.17,2.41,15.5,15.5,0,0,1-.16,3.31,7.54,7.54,0,0,1-2,3.63l-3.27,3.68-8,9,0-.13c0,1.32,0,2.77,0,4.25l-.2-.2h.36a.91.91,0,0,1,.45.11,1,1,0,0,1,.51.77,1,1,0,0,1-.43.86,1,1,0,0,1-.47.16H450l.21-.21c0,1.08,0,2.29,0,3.52v.22H450l-16.18.13h-.25V221.2l.24.24h-.36a1,1,0,0,1-.45-.14,1,1,0,0,1-.06-1.66,1.47,1.47,0,0,1,.87-.19l-.25.25v-4.39l.07.18-7-7.13-3.64-3.69c-.6-.64-1.24-1.21-1.82-1.93a7.66,7.66,0,0,1-1.26-2.42,7.8,7.8,0,0,1-.31-2.14v-3.12a4.42,4.42,0,0,1,.16-1.09,4.21,4.21,0,0,1,1.12-1.84l-.07.18c0-6.61,0-13,0-19V173H421l41.31.09h.16v.16c0,5.86-.06,10.49-.08,13.7,0,1.57,0,2.79,0,3.65l0,.94a2.4,2.4,0,0,1,0,.33,1.92,1.92,0,0,1,0-.31c0-.23,0-.54,0-.93,0-.85,0-2.07,0-3.63,0-3.22-.05-7.87-.08-13.75l.16.16-41.31.09.24-.25c0,6,0,12.43,0,19v.11l-.08.07a3.67,3.67,0,0,0-1,1.63,7,7,0,0,0-.14,2v2.08a6.82,6.82,0,0,0,1.46,4.24c.52.65,1.19,1.25,1.78,1.88l3.64,3.69,7,7.14.08.08v.1c0,1.52,0,3,0,4.39V220h-.25a.94.94,0,0,0-.59.1.5.5,0,0,0-.21.43.51.51,0,0,0,.47.47H434v3.87l-.25-.24,16.19-.07-.22.21c0-1.23,0-2.44,0-3.52V221H450a1.09,1.09,0,0,0,.66-.1.51.51,0,0,0,.24-.48.52.52,0,0,0-.28-.44.58.58,0,0,0-.26-.06h-.56v-.21c0-1.48,0-2.93,0-4.25v-.07l.05,0c3-3.32,5.68-6.31,8.05-8.94l3.31-3.65a7.29,7.29,0,0,0,2-3.5,15.13,15.13,0,0,0,.2-3.26,9.17,9.17,0,0,0-.11-2.38A4.21,4.21,0,0,0,462.31,191.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.6,222.85v10.66s.12,2.16-10.05,2.16c-9.25,0-9.22-2.49-9.22-2.49V222.85Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.35,225s.08,1.84.08,4.11,0,4.1-.08,4.1-.09-1.83-.09-4.1S450.3,225,450.35,225Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.63,225s.08,1.94.08,4.34,0,4.33-.08,4.33-.09-1.94-.09-4.33S448.58,225,448.63,225Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447,225s.08,2,.08,4.5S447,234,447,234s-.09-2-.09-4.49S446.92,225,447,225Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.31,225c.05,0,.08,2.06.08,4.61s0,4.6-.08,4.6-.09-2.06-.09-4.6S445.26,225,445.31,225Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.65,225c.05,0,.08,2.06.08,4.61s0,4.6-.08,4.6-.08-2.06-.08-4.6S443.6,225,443.65,225Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442,225c.05,0,.09,2.06.09,4.61s0,4.6-.09,4.6-.08-2.06-.08-4.6S441.94,225,442,225Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.33,225c.05,0,.09,2.06.09,4.61s0,4.6-.09,4.6-.08-2.06-.08-4.6S440.29,225,440.33,225Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.67,225c.05,0,.09,2.06.09,4.61s0,4.6-.09,4.6-.08-2.06-.08-4.6S438.63,225,438.67,225Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437,225s.08,2,.08,4.45,0,4.44-.08,4.44-.09-2-.09-4.44S437,225,437,225Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.36,225s.08,1.91.08,4.26,0,4.27-.08,4.27-.09-1.91-.09-4.27S435.31,225,435.36,225Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.7,225s.08,1.81.08,4,0,4-.08,4-.09-1.8-.09-4S433.65,225,433.7,225Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433,232.78l.18.05.52.15.82.23c.32.09.69.2,1.1.28s.85.2,1.34.28,1,.17,1.55.25a32.93,32.93,0,0,0,3.6.24,33.37,33.37,0,0,0,3.6-.2c.55-.08,1.07-.14,1.55-.23s.94-.18,1.35-.27.77-.18,1.1-.26l.82-.23.52-.14.18,0-.17.07-.51.17c-.22.08-.5.17-.82.26s-.68.2-1.09.28-.86.2-1.35.29-1,.16-1.56.24a31.29,31.29,0,0,1-3.62.22,28.64,28.64,0,0,1-3.62-.26c-.55-.08-1.08-.16-1.56-.26s-.93-.2-1.34-.3-.77-.21-1.1-.3-.59-.18-.81-.26l-.51-.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.91,224.94c0-.05,4-.08,9-.08s9,0,9,.08-4,.08-9,.08S432.91,225,432.91,224.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.6,120a3,3,0,0,1-.17.68c-.15.49-.35,1.13-.59,1.93s-.59,1.85-.92,3-.75,2.54-1.12,4.06-.83,3.16-1.22,4.95-.8,3.71-1.21,5.73c-.75,4-1.44,8.53-1.92,13.27s-.68,9.27-.74,13.39c0,2.06,0,4,.05,5.85s.13,3.54.22,5.1.21,3,.3,4.2.2,2.29.3,3.16.14,1.5.19,2a3.69,3.69,0,0,1,0,.7,3.25,3.25,0,0,1-.13-.69l-.29-2c-.12-.86-.26-1.92-.37-3.16s-.29-2.64-.37-4.2-.23-3.27-.28-5.11-.08-3.8-.09-5.87c0-4.13.24-8.68.7-13.43s1.19-9.24,2-13.3c.42-2,.8-3.95,1.25-5.74s.86-3.44,1.28-4.95.83-2.86,1.19-4,.7-2.21,1-3l.68-1.9A6.1,6.1,0,0,1,449.6,120Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.93,142a11.7,11.7,0,0,1,4.89-6.18,2.78,2.78,0,0,1,2.58-.47c1.1.53,1.19,2.07.86,3.24a8.6,8.6,0,0,1-3.56,4.86,7.27,7.27,0,0,1-5.34,1.34",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442,156.87c.81-3.07,3.26-7.44,5.8-9.34a3.74,3.74,0,0,1,1.32-.7,1.52,1.52,0,0,1,1.41.31,2.15,2.15,0,0,1,.32,2,12.38,12.38,0,0,1-9.18,9.24",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.49,170a17.89,17.89,0,0,1,5.86-7.36,2.76,2.76,0,0,1,2-.73c1.11.2,1.61,1.55,1.52,2.68-.21,2.31-2,4.17-3.8,5.61a23.51,23.51,0,0,1-5.42,2.78",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.79,179.37a17.1,17.1,0,0,1,5-5.67,3.53,3.53,0,0,1,1.49-.67,1.52,1.52,0,0,1,1.47.55c.5.74,0,1.73-.51,2.44a14.24,14.24,0,0,1-7.11,5.21",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.54,175.55a55.51,55.51,0,0,0-7.12-7.26c-.41-.34-.92-.7-1.42-.54a1.08,1.08,0,0,0-.66,1,2.91,2.91,0,0,0,.27,1.19,13.85,13.85,0,0,0,9.18,7.72",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.77,163.3l-5.6-6.82a6.66,6.66,0,0,0-1.82-1.73A2,2,0,0,0,431.2,157a6.07,6.07,0,0,0,1.09,2.24,16.67,16.67,0,0,0,4.08,4.33c1.64,1.13,3.14,1.87,5.11,1.58",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.55,149.51a19.51,19.51,0,0,0-5.64-8.45,3.26,3.26,0,0,0-1.46-.86,2.47,2.47,0,0,0-2.57,1.8,4.63,4.63,0,0,0,.51,3.71,9.8,9.8,0,0,0,2.63,2.78,22.36,22.36,0,0,0,6.23,3.36",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.78,137.22c-.54-3.95-2.6-7.25-5-10.45-.5-.67-1.2-1.39-2-1.26a1.62,1.62,0,0,0-1.17,1,3.7,3.7,0,0,0-.22,1.58A12.22,12.22,0,0,0,444.3,139",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.35,130.94a32.88,32.88,0,0,1-.21-6.11,11,11,0,0,1,2-5.7,4.75,4.75,0,0,1,2-1.62,2.57,2.57,0,0,1,2.49.33,2.73,2.73,0,0,1,.85,2.2,6.9,6.9,0,0,1-.63,2.34c-1.49,3.59-4,7.56-6.57,8.56",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422,135.66a2.42,2.42,0,0,1,0,.5c0,.38,0,.85,0,1.43,0,1.25.05,3,.16,5.28s.32,4.86.66,7.78.87,6.12,1.55,9.45,1.54,6.45,2.38,9.27,1.72,5.32,2.52,7.4,1.48,3.75,2,4.89c.23.53.41,1,.56,1.32a1.73,1.73,0,0,1,.16.48,3.07,3.07,0,0,1-.25-.44l-.63-1.29c-.55-1.12-1.28-2.77-2.12-4.84s-1.74-4.58-2.63-7.4-1.71-6-2.41-9.3-1.18-6.55-1.53-9.49-.5-5.59-.56-7.82-.06-4,0-5.29l.06-1.43A1.65,1.65,0,0,1,422,135.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.84,151.87a8.31,8.31,0,0,1,2-5.25,2,2,0,0,1,1.66-.88c.86.12,1.25,1.15,1.28,2a6.13,6.13,0,0,1-1.38,4.07,5.19,5.19,0,0,1-3.34,2.07",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.74,162.41a14.09,14.09,0,0,1,1.95-7.61,2.68,2.68,0,0,1,.74-.76,1.11,1.11,0,0,1,1-.09,1.51,1.51,0,0,1,.65,1.32,8.83,8.83,0,0,1-4.26,8.26",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.2,171.43a13,13,0,0,1,2.4-6.27,2,2,0,0,1,1.24-.93c.8-.11,1.43.71,1.61,1.5.36,1.62-.45,3.26-1.38,4.63a16.54,16.54,0,0,1-3.09,3.06",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.43,177.78a12.34,12.34,0,0,1,2.17-4.94,2.46,2.46,0,0,1,.87-.77,1.09,1.09,0,0,1,1.12.06c.5.39.39,1.17.18,1.77a10.14,10.14,0,0,1-3.72,5.08",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.44,175.23a40.18,40.18,0,0,0-6.41-3.41,1.15,1.15,0,0,0-1.09-.06.77.77,0,0,0-.23.79,1.74,1.74,0,0,0,.44.75,9.83,9.83,0,0,0,7.9,3.28",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426,166.84l-5.28-3.44a4.72,4.72,0,0,0-1.61-.78,1.65,1.65,0,0,0-1.63.49,1.62,1.62,0,0,0,0,1.7,4.2,4.2,0,0,0,1.23,1.29,12,12,0,0,0,3.71,2.08,4.91,4.91,0,0,0,3.82,0",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.52,157.29a13.94,13.94,0,0,0-5.65-4.55,2.38,2.38,0,0,0-1.19-.26,1.76,1.76,0,0,0-1.36,1.78,3.32,3.32,0,0,0,1.15,2.41,7,7,0,0,0,2.39,1.33,16.46,16.46,0,0,0,5,.95",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.4,148.44a16.19,16.19,0,0,0-5.65-6,1.74,1.74,0,0,0-1.66-.43,1.18,1.18,0,0,0-.58.94,2.87,2.87,0,0,0,.19,1.12,8.74,8.74,0,0,0,7.75,5.73",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.11,143.83a23.73,23.73,0,0,1-1.45-4.12,7.83,7.83,0,0,1,.15-4.32,3.36,3.36,0,0,1,1-1.54,1.84,1.84,0,0,1,1.77-.31,1.94,1.94,0,0,1,1.05,1.31,5,5,0,0,1,.07,1.73c-.24,2.76-1.08,6-2.63,7.25",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.72,135.31a2,2,0,0,1,0,.5c0,.38,0,.86.07,1.44.05,1.24.05,3.05,0,5.28s-.25,4.89-.57,7.83-.83,6.15-1.52,9.49-1.55,6.47-2.42,9.3-1.78,5.32-2.63,7.39-1.56,3.73-2.11,4.85l-.64,1.29c-.14.29-.23.44-.25.43a3.14,3.14,0,0,1,.17-.47l.55-1.33c.5-1.14,1.18-2.81,2-4.89s1.67-4.58,2.53-7.4,1.67-6,2.37-9.27,1.19-6.52,1.55-9.44.56-5.56.66-7.79.16-4,.16-5.27q0-.87,0-1.44A1.84,1.84,0,0,1,461.72,135.31Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.84,151.53a8.34,8.34,0,0,0-2-5.26,2,2,0,0,0-1.65-.88c-.86.13-1.26,1.16-1.29,2a6.15,6.15,0,0,0,1.38,4.07,5.16,5.16,0,0,0,3.35,2.06",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.94,162.06a14,14,0,0,0-1.94-7.6,2.59,2.59,0,0,0-.75-.76,1.07,1.07,0,0,0-1-.1,1.57,1.57,0,0,0-.66,1.32,8.83,8.83,0,0,0,4.26,8.26",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.48,171.09a12.71,12.71,0,0,0-2.4-6.27,2,2,0,0,0-1.23-.94c-.8-.1-1.44.71-1.61,1.5-.36,1.62.44,3.26,1.37,4.64a16.87,16.87,0,0,0,3.09,3.06",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.26,177.43a12.44,12.44,0,0,0-2.17-4.93,2.63,2.63,0,0,0-.88-.78,1.1,1.1,0,0,0-1.12.06c-.49.4-.38,1.17-.17,1.77a10.06,10.06,0,0,0,3.72,5.08",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.25,174.88a38.93,38.93,0,0,1,6.41-3.4,1.13,1.13,0,0,1,1.08-.06.75.75,0,0,1,.24.79,1.91,1.91,0,0,1-.44.75,9.87,9.87,0,0,1-7.91,3.28",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.73,166.5l5.28-3.44a4.74,4.74,0,0,1,1.61-.79,1.64,1.64,0,0,1,1.63.5,1.62,1.62,0,0,1,0,1.7,4.28,4.28,0,0,1-1.22,1.29,12,12,0,0,1-3.71,2.07,4.83,4.83,0,0,1-3.82,0",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.17,156.94a13.91,13.91,0,0,1,5.65-4.54,2.27,2.27,0,0,1,1.18-.27,1.77,1.77,0,0,1,1.36,1.78,3.29,3.29,0,0,1-1.14,2.41,7,7,0,0,1-2.39,1.33,15.86,15.86,0,0,1-5,.95",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.29,148.09a16.4,16.4,0,0,1,5.64-6c.49-.35,1.12-.69,1.66-.42a1.12,1.12,0,0,1,.58.93,2.57,2.57,0,0,1-.19,1.13,8.69,8.69,0,0,1-7.75,5.72",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.58,143.48a23.16,23.16,0,0,0,1.45-4.12,7.79,7.79,0,0,0-.16-4.31,3.26,3.26,0,0,0-1-1.54,1.84,1.84,0,0,0-1.77-.32A1.91,1.91,0,0,0,459,134.5a4.84,4.84,0,0,0-.08,1.74c.25,2.76,1.08,6,2.64,7.24",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 441.7,
    cy: 181.87,
    rx: 16.94,
    ry: 1.42,
    style: {
      fill: "#ae7461"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.74,194.46s-2.09-.2-2-.2a17.44,17.44,0,0,1-1.36,1.36l1.68,1.43,1.67-.86Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.26,197.5a14.11,14.11,0,0,0,1.59.28l-.46,1.13-1.13.6-1-.5a5.77,5.77,0,0,1,.3-1.26A4.84,4.84,0,0,0,445.26,197.5Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.06,206a14.26,14.26,0,0,0,1.6.28l-.47,1.13-1.13.6-1-.5a5.85,5.85,0,0,1,.3-1.27A4.77,4.77,0,0,0,437.06,206Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.06,203.25l.64.48.49.93-1.13.6-1-.5a5.77,5.77,0,0,1,.3-1.26A4.65,4.65,0,0,0,437.06,203.25Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "449.28 197.72 448.31 198.26 448.65 199.01 449.48 199.28 450.48 198.5 450.31 197.95 449.28 197.72",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "433.59 187.69 432.63 188.23 432.96 188.99 433.79 189.25 434.79 188.48 434.62 187.92 433.59 187.69",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.75,193.64a2.86,2.86,0,0,1,0,.3l0,.92c0,.85,0,2.06,0,3.63,0,3.22.05,7.89.08,13.8v.05l0,0a2.5,2.5,0,0,0,0,2.84l0,0v.05c0,4,0,8.58,0,13.55a17.23,17.23,0,0,1-1.54,7.64,7.24,7.24,0,0,1-2.62,3.25,7,7,0,0,1-4.16,1.12h-3.26a2.15,2.15,0,0,1-1.18-.33,2.54,2.54,0,0,1-.82-.88l-.31-.47a.61.61,0,0,0-.31-.26.72.72,0,0,0-.78.14.94.94,0,0,0-.23.4,2.29,2.29,0,0,1-.31.55,2,2,0,0,1-1,.73,4.7,4.7,0,0,1-1.21.09l-2.32,0-4.72.08a3.46,3.46,0,0,1-2.34-.93A3.61,3.61,0,0,1,436,239l-.12-.29a.86.86,0,0,0-.11-.19.67.67,0,0,0-.37-.23.72.72,0,0,0-.8.34l-.75,1a3.47,3.47,0,0,1-2.29,1.22c-.88,0-1.67,0-2.51,0a12.9,12.9,0,0,1-2.54-.14,7.14,7.14,0,0,1-4.31-2.77,15.69,15.69,0,0,1-2.59-5.84,23.53,23.53,0,0,1-.6-6.23q.07-6.14.15-12V214a10.8,10.8,0,0,1-.33-2.76l0-2.68c0-1.78,0-3.52.06-5.24.05-3.43.09-6.74.13-9.91v-.22h.22l32.29.31,9,.12,2.35,0h.6l.2,0H451.46l-32.15-.08.23-.22c0,3.17-.07,6.47-.1,9.91,0,1.71,0,3.46-.05,5.23a20,20,0,0,0,.3,5.31v.07c0,3.88-.09,7.88-.14,12a23.67,23.67,0,0,0,.59,6.09,15.2,15.2,0,0,0,2.5,5.65,6.56,6.56,0,0,0,4,2.58,13,13,0,0,0,2.44.13c.82,0,1.69,0,2.45,0a3,3,0,0,0,2-1l.75-1a1.24,1.24,0,0,1,1.32-.52,1.17,1.17,0,0,1,.64.4,1.09,1.09,0,0,1,.19.33l.12.26a3,3,0,0,0,.64.89,3,3,0,0,0,2,.8l4.7-.07,2.32,0a5.11,5.11,0,0,0,1.08-.07,1.52,1.52,0,0,0,.79-.56,2.09,2.09,0,0,0,.25-.44,1.36,1.36,0,0,1,.34-.56,1.2,1.2,0,0,1,1.31-.24,1.15,1.15,0,0,1,.53.44l.3.47a2,2,0,0,0,.67.74,1.79,1.79,0,0,0,.93.26h3.26a6.52,6.52,0,0,0,3.91-1,6.74,6.74,0,0,0,2.46-3.05,16.9,16.9,0,0,0,1.54-7.45c0-5,0-9.51,0-13.55l0,.1a2.79,2.79,0,0,1,0-3.21l0,.09c0-5.87.06-10.51.08-13.71,0-1.58,0-2.8,0-3.66l0-.95A2.06,2.06,0,0,1,463.75,193.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.66,212.61s-9.94.1-22.19.1-22.18-.05-22.18-.1,9.93-.1,22.18-.1S463.66,212.55,463.66,212.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.9,215.51c0,.05-9.93.1-22.18.1s-22.18-.05-22.18-.1,9.93-.1,22.18-.1S463.9,215.45,463.9,215.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.16,240.61a.86.86,0,0,1-.33-.1,2.8,2.8,0,0,1-.77-.54,11.31,11.31,0,0,1-1.68-2.57c-.58-1-1.1-2-1.46-2.68a8.44,8.44,0,0,1-.56-1.14,9.61,9.61,0,0,1,.68,1.07c.4.68.93,1.61,1.51,2.66a13.82,13.82,0,0,0,1.61,2.56A4.16,4.16,0,0,0,438.16,240.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.57,234a3.44,3.44,0,0,1-.2.85c-.16.52-.39,1.22-.69,2s-.59,1.45-.82,1.94a4.35,4.35,0,0,1-.42.77,3.71,3.71,0,0,1,.29-.82c.22-.58.48-1.23.77-2l.73-2A3.78,3.78,0,0,1,450.57,234Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421,172.77s0-.15.07-.45l.24-1.34,1-5.22c.86-4.58,2.09-11.2,3.63-19.46,3.13-16.6,7.51-39.78,12.49-66.2l.21-1.13.29,1.12c1.75,6.88,3.57,14,5.44,21.33,7,27.44,13.34,52.58,18.22,71.8l.05.18-.18.06a69.8,69.8,0,0,1-17.23,3.29,57.31,57.31,0,0,1-13.28-.73,52.2,52.2,0,0,1-8.16-2.14c-.91-.33-1.6-.64-2.06-.82l-.68-.29.73.25c.47.17,1.14.44,2.05.75a54,54,0,0,0,8.16,2,58,58,0,0,0,13.22.63,69.76,69.76,0,0,0,17.13-3.35l-.13.24-18.35-71.77c-1.86-7.31-3.68-14.45-5.43-21.34h.5c-5.06,26.34-9.49,49.45-12.67,66-1.61,8.27-2.89,14.9-3.78,19.48l-1,5.25c-.12.59-.21,1-.28,1.37S421,172.77,421,172.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.37,78.64a3.41,3.41,0,1,1-3.4-3.41A3.4,3.4,0,0,1,442.37,78.64Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--plant-4--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M369.14,170.06h-3v-.31a.73.73,0,0,0-.52-.74.66.66,0,0,0-.73.7v.35h-3.57l-10.92-11a5.65,5.65,0,0,0-4-1.73h-2.55a3.11,3.11,0,0,0-2.3,1.07s-1.18,15.55-35.26,15.67S277,158.2,277,158.2l-2.18.07-9.86-.14a16,16,0,0,0-4.75.63c-2.85.84-6.41,2.74-6.41,7v2.91a3,3,0,0,0,1,2.23l.77.68a.9.9,0,0,1-.2,1.46h0a2.84,2.84,0,0,0-1.65,2.7l.09,6.77a1.61,1.61,0,0,0,1,1.49.9.9,0,0,1,.15,1.51l-.53.39a1.81,1.81,0,0,0-.71,1.46v3.27a5.89,5.89,0,0,0,2.63,5l.09.05a11.93,11.93,0,0,0,6.22,1.71h11a1.9,1.9,0,0,1,2.38,0h15.37a1.31,1.31,0,0,1,2-.06l.07.06h48.5l.06.07a3.07,3.07,0,0,0,2.3,1.07h2.57a5.69,5.69,0,0,0,4.21-1.94l10.16-11.27h3.69v.25a.71.71,0,0,0,.52.73.66.66,0,0,0,.73-.69v-.29h3.05Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.25,171.65h-2.33v-.26a.6.6,0,0,0-.41-.61c-.31-.06-.57.22-.57.58v.29h-2.81l-8.59-9.13a4.31,4.31,0,0,0-3.15-1.43h-2a2.37,2.37,0,0,0-1.81.89l-68.64-.33a5.34,5.34,0,0,0-1.68.24l-4-.12a11.91,11.91,0,0,0-3.74.52c-2.24.69-5,2.27-5,5.8v2.41a2.54,2.54,0,0,0,.76,1.85l.61.56a.77.77,0,0,1-.16,1.21h0a2.37,2.37,0,0,0-1.3,2.23l.08,5.61a1.34,1.34,0,0,0,.82,1.24.76.76,0,0,1,.12,1.25l-.42.32a1.53,1.53,0,0,0-.55,1.21v2.71a4.93,4.93,0,0,0,2.06,4.16l.07,0a9,9,0,0,0,4.89,1.42h22.74a1.43,1.43,0,0,1,1.88,0h12.08a1,1,0,0,1,1.55-.05l.05.05h38.14l0,.05a2.39,2.39,0,0,0,1.81.89h2a4.37,4.37,0,0,0,3.32-1.61l8-9.33h2.9v.21a.57.57,0,0,0,.41.6.52.52,0,0,0,.57-.57v-.24h2.4Z",
    style: {
      fill: "#6f4439"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.54,162.52a4.31,4.31,0,0,0-3.15-1.43h-2a2.37,2.37,0,0,0-1.81.89l-68.64-.33a5.34,5.34,0,0,0-1.68.24l-4-.12a11.91,11.91,0,0,0-3.74.52,9.1,9.1,0,0,0-3.06,1.57,165.54,165.54,0,0,0,53.05,7.48c12.25-.28,24.91-2.08,35.31-8.57Z",
    style: {
      fill: "#ae7461"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.23,197.42s-.08-5.49-.08-12.27,0-12.27.08-12.27.08,5.5.08,12.27S291.27,197.42,291.23,197.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.79,197.34s-.08-8.81-.08-19.68,0-19.68.08-19.68.08,8.81.08,19.68S275.83,197.34,275.79,197.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.5,197.56s-.07-8.81-.07-19.68,0-19.68.07-19.68.08,8.81.08,19.68S273.55,197.56,273.5,197.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.6,197.42s-.08-5.42-.08-12.11,0-12.12.08-12.12.08,5.43.08,12.12S293.65,197.42,293.6,197.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.74,175a.65.65,0,0,1,.07-.29,2.64,2.64,0,0,1,.43-.68,8.67,8.67,0,0,1,2-1.49c.82-.52,1.57-1,2.12-1.3a5.74,5.74,0,0,1,.9-.5,6.85,6.85,0,0,1-.85.6c-.53.36-1.27.83-2.09,1.35a10.52,10.52,0,0,0-2,1.43A3.13,3.13,0,0,0,253.74,175Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.35,186a2.16,2.16,0,0,1-.67-.18c-.4-.13-1-.34-1.57-.61s-1.14-.52-1.53-.73a2.57,2.57,0,0,1-.6-.37,3.14,3.14,0,0,1,.65.26l1.54.68,1.55.66A3.18,3.18,0,0,1,259.35,186Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.76,197.4c-.05,0-.08-8.71-.08-19.46s0-19.47.08-19.47.07,8.72.07,19.47S341.8,197.4,341.76,197.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.25,185.39s-.09-3.43-.11-7.67,0-7.66,0-7.66.1,3.43.12,7.66S366.3,185.39,366.25,185.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.93,185.78c-.05,0-.08-3.51-.08-7.84s0-7.85.08-7.85.07,3.51.07,7.85S365,185.78,364.93,185.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.85,185.35c-.05,0-.08-3.42-.08-7.63s0-7.63.08-7.63.07,3.42.07,7.63S363.89,185.35,363.85,185.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.77,185.35s-.08-3.42-.08-7.63,0-7.63.08-7.63.07,3.42.07,7.63S362.81,185.35,362.77,185.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.9,170.09a1.79,1.79,0,0,0-.71,1.08,5.69,5.69,0,0,0-.14,1.37,103.6,103.6,0,0,0,.42,12c0,.32.11.71.39.79,0-.64,0-1.28,0-1.92,0-3.81,0-7.61,0-11.42,0-.7,0-1.39,0-2.09",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.13,167.44h10.31s2.09-.12,2.09,10.42c0,9.59-2.41,9.56-2.41,9.56h-10Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.17,168.74c0-.05,1.78-.09,4-.09s4,0,4,.09-1.78.09-4,.09S369.17,168.79,369.17,168.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.17,170.52s1.88-.08,4.19-.08,4.19,0,4.19.08-1.88.09-4.19.09S369.17,170.57,369.17,170.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.17,172.24s1.95-.08,4.35-.08,4.35,0,4.35.08-1.95.09-4.35.09S369.17,172.29,369.17,172.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.17,174c0-.05,2-.08,4.45-.08s4.46,0,4.46.08-2,.09-4.46.09S369.17,174,369.17,174Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.17,175.68c0-.05,2-.09,4.45-.09s4.46,0,4.46.09-2,.09-4.46.09S369.17,175.73,369.17,175.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.17,177.4c0-.05,2-.09,4.45-.09s4.46,0,4.46.09-2,.09-4.46.09S369.17,177.45,369.17,177.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.17,179.12c0-.05,2-.09,4.45-.09s4.46,0,4.46.09-2,.09-4.46.09S369.17,179.17,369.17,179.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.17,180.84c0-.05,2-.09,4.45-.09s4.46,0,4.46.09-2,.09-4.46.09S369.17,180.89,369.17,180.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.17,182.56c0-.05,1.92-.09,4.3-.09s4.29,0,4.29.09-1.92.09-4.29.09S369.17,182.61,369.17,182.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.17,184.28c0-.05,1.84-.09,4.12-.09s4.12,0,4.12.09-1.84.09-4.12.09S369.17,184.33,369.17,184.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.17,186c0-.05,1.74-.09,3.89-.09s3.89,0,3.89.09-1.74.09-3.89.09S369.17,186.05,369.17,186Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.73,186.7a1.22,1.22,0,0,1,0-.19c0-.14.08-.32.14-.54s.15-.51.23-.85.18-.71.27-1.13.19-.89.27-1.39.16-1,.24-1.61a35.39,35.39,0,0,0,.23-3.73,35.75,35.75,0,0,0-.2-3.73c-.07-.57-.13-1.11-.22-1.61s-.17-1-.25-1.4-.18-.8-.26-1.14-.15-.62-.22-.85-.1-.39-.14-.54,0-.19,0-.19a.62.62,0,0,1,.07.18l.17.53c.08.23.16.51.25.85s.19.71.27,1.13.2.89.28,1.4.16,1.05.24,1.62a36.19,36.19,0,0,1,.21,3.75,35.36,35.36,0,0,1-.25,3.75c-.09.57-.16,1.12-.26,1.62s-.19,1-.29,1.39-.2.8-.29,1.13a8.37,8.37,0,0,1-.25.85l-.18.52A.62.62,0,0,1,376.73,186.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.14,186.81s-.07-4.16-.07-9.3,0-9.3.07-9.3.08,4.16.08,9.3S369.19,186.81,369.14,186.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.14,170.06s0,.32,0,1,0,1.65,0,2.92c0,2.61.07,6.44.13,11.4v.11h-3.16l.12-.12a1.36,1.36,0,0,1-.08.67.74.74,0,0,1-.6.44.7.7,0,0,1-.69-.37,1.31,1.31,0,0,1-.13-.74l.13.13h-3.69l.11-.05-7.74,8.63-2.16,2.4a6.38,6.38,0,0,1-2.77,2,5.45,5.45,0,0,1-1.75.3h-2.64a3,3,0,0,1-.93-.15,3.36,3.36,0,0,1-1.56-1l.14.06-48.5,0h-.11l-.06-.07a1.09,1.09,0,0,0-1.67,0l-.07.09H276l-.06,0a1.67,1.67,0,0,0-2.08,0l-.06.06H264.8a23.48,23.48,0,0,1-4.56-.23,11.89,11.89,0,0,1-4.31-1.75,6,6,0,0,1-2.4-4,17.17,17.17,0,0,1-.09-2.36v-1.17a8.7,8.7,0,0,1,.05-1.22,2,2,0,0,1,.67-1.14c.31-.27.72-.46.81-.68a.68.68,0,0,0-.15-.77c-.06-.06-.3-.13-.5-.27a2,2,0,0,1-.49-.47,2,2,0,0,1-.35-1.27l0-1.18,0-2.38c0-.9,0-1.81,0-2.71a3.41,3.41,0,0,1,.93-2.66,3.12,3.12,0,0,1,.59-.44,2.87,2.87,0,0,1,.32-.15.75.75,0,0,0,.17-.14.67.67,0,0,0-.07-.87c-.33-.3-.66-.55-1-.91a3.09,3.09,0,0,1-.69-1.27,4.18,4.18,0,0,1-.13-1.39v-1.32a12.28,12.28,0,0,1,.17-2.69,6.81,6.81,0,0,1,3.17-4.26,14.14,14.14,0,0,1,4.93-1.82,25.63,25.63,0,0,1,5.16-.21L272,158l2.5,0c.83,0,1.65-.05,2.47-.07h.33l-.08.33a9,9,0,0,0,.62,5.63,10.86,10.86,0,0,0,3.58,4.36c3,2.32,6.71,3.44,10.27,4.26a48.46,48.46,0,0,0,5.39.82c1.8.18,3.57.38,5.33.38,3.51.17,6.94,0,10.27-.11,6.64-.43,12.91-1.61,18.21-4.05a18.34,18.34,0,0,0,1.94-.95l1.82-1.08c.56-.41,1.11-.84,1.65-1.24a17.79,17.79,0,0,0,1.5-1.37,12.43,12.43,0,0,0,3.64-6.55v-.06l0,0a3.25,3.25,0,0,1,1.83-1.07,15.54,15.54,0,0,1,2-.05,12.76,12.76,0,0,1,1.95.07,5.56,5.56,0,0,1,1.8.61,12.37,12.37,0,0,1,2.7,2.34l2.3,2.34,7.35,7.48-.06,0,3.57,0-.07.07a1.12,1.12,0,0,1,.24-.92.62.62,0,0,1,.75-.12,1,1,0,0,1,.38,1l-.05-.05,2.25,0c.49,0,.71,0,.71,0l-.74,0-2.22,0h-.05v-.05a.93.93,0,0,0-.34-.94.5.5,0,0,0-.61.11c-.2.18-.2.47-.19.83v.06h-.07l-3.57,0h0l0,0-7.4-7.41-2.32-2.33a12,12,0,0,0-2.64-2.28,5.62,5.62,0,0,0-1.72-.57,14.78,14.78,0,0,0-1.9-.06,18,18,0,0,0-2,.06,3,3,0,0,0-1.66,1l0-.09a12.66,12.66,0,0,1-3.71,6.77,16.92,16.92,0,0,1-1.52,1.4c-.55.41-1.1.85-1.68,1.26L333,168.94a17.86,17.86,0,0,1-2,1c-5.35,2.48-11.67,3.69-18.34,4.13-3.34.16-6.79.3-10.32.13a51.54,51.54,0,0,1-5.36-.37,49.33,49.33,0,0,1-5.44-.82c-3.6-.82-7.34-1.94-10.47-4.33a11.3,11.3,0,0,1-3.73-4.55l-.31-.69c-.09-.24-.14-.49-.21-.73l-.19-.73-.1-.76a8.34,8.34,0,0,1,.16-3.06l.25.32c-.83,0-1.66.07-2.49.07l-2.5,0-5.06-.07a25.14,25.14,0,0,0-5.06.21,13.44,13.44,0,0,0-4.74,1.75,6.33,6.33,0,0,0-3,3.93,11.49,11.49,0,0,0-.15,2.58v1.32a3.89,3.89,0,0,0,.11,1.25,2.69,2.69,0,0,0,.58,1.06c.27.28.65.58,1,.87a1.18,1.18,0,0,1,.12,1.58.78.78,0,0,1-.34.28l-.29.14a1.92,1.92,0,0,0-.48.37,2.85,2.85,0,0,0-.78,2.28c0,.9,0,1.8,0,2.7l0,2.38,0,1.19a1.49,1.49,0,0,0,.26,1,1.26,1.26,0,0,0,.35.34c.13.1.29.12.54.3a1.19,1.19,0,0,1,.29,1.39,1.38,1.38,0,0,1-.49.52l-.46.34a1.49,1.49,0,0,0-.49.85,7.83,7.83,0,0,0,0,1.11v1.17a17,17,0,0,0,.08,2.28,5.51,5.51,0,0,0,2.19,3.7,11.54,11.54,0,0,0,4.11,1.67,23.57,23.57,0,0,0,4.46.22h8.86l-.16.05a2.2,2.2,0,0,1,1.39-.47,2.26,2.26,0,0,1,1.31.47l-.16-.05h15.37l-.18.08a1.58,1.58,0,0,1,1.24-.55,1.61,1.61,0,0,1,1.14.54l-.17-.07,48.5,0H342l.05.07a3.11,3.11,0,0,0,1.39.94,5.63,5.63,0,0,0,1.71.14,10.15,10.15,0,0,0,3.38-.28,5.93,5.93,0,0,0,2.63-1.86l2.17-2.4,7.78-8.58,0,0h3.88v.13a1.07,1.07,0,0,0,.09.61.47.47,0,0,0,.45.25.51.51,0,0,0,.4-.3,1.24,1.24,0,0,0,.06-.56v-.12h3.17l-.11.11V174c0-1.29,0-2.27,0-3S369.14,170.06,369.14,170.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291,162.75s-17.76-20.47-15.79-21.21S293,152.15,293,152.15s-13.56-30.34-10.85-32.55,17,26.87,17,26.87-2.22-42.41,0-42.9S309.48,146,309.48,146s12.08-39.21,15.54-39.21-3.7,37.73-3.7,37.73,14.3-24.16,16.52-21-10.11,29.35-10.11,29.35,18-15,18.74-13.07S327,162.75,327,162.75Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.51,131.93c.12-.06,3.27,6.69,7,15.07s6.71,15.23,6.59,15.28-3.27-6.69-7-15.08S288.39,132,288.51,131.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.85,135.7c.14,0,.66,5.94,1.17,13.29s.82,13.31.68,13.32-.65-5.94-1.17-13.29S302.72,135.71,302.85,135.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.64,116.7a2.05,2.05,0,0,1-.11.48q-.15.54-.39,1.35l-1.48,4.94c-1.25,4.17-2.94,9.95-4.65,16.37s-3.13,12.27-4.13,16.51c-.48,2.07-.88,3.77-1.17,5l-.33,1.36a3.44,3.44,0,0,1-.15.47,1.65,1.65,0,0,1,0-.49q.11-.56.24-1.38c.22-1.2.57-2.93,1-5.06.91-4.27,2.27-10.13,4-16.56s3.45-12.2,4.79-16.35c.67-2.07,1.23-3.75,1.63-4.9l.48-1.32A1.6,1.6,0,0,1,322.64,116.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.19,138.57c.11.07-3.35,5.24-7.74,11.54s-8,11.34-8.14,11.26,3.36-5.24,7.74-11.54S331.08,138.49,331.19,138.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297,162.32a7,7,0,0,1-1.56-1.11,44.11,44.11,0,0,1-3.37-3.12,41.67,41.67,0,0,1-3-3.46,7,7,0,0,1-1.07-1.58c.12-.09,2,2.15,4.45,4.7S297.07,162.21,297,162.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.76,154.18a18.27,18.27,0,0,1,.63,4.23,19.58,19.58,0,0,1,.15,4.26,18.12,18.12,0,0,1-.63-4.22A19,19,0,0,1,307.76,154.18Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--plant-3--inject-2"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 196.91,
    cy: 81.53,
    rx: 2.52,
    ry: 10.76,
    transform: "translate(-2.58 6.53) rotate(-1.89)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 189.5,
    cy: 92.47,
    rx: 2.52,
    ry: 10.76,
    transform: "translate(-2.94 6.29) rotate(-1.89)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.56,106.12c-.72-4.55-.35-8.67.8-11,1.82,1.89,3.45,5.69,4.18,10.24s.35,8.66-.8,11C181.92,114.47,180.28,110.66,179.56,106.12Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.41,87.91c4.56-.66,8.67-.24,11,1-1.91,1.79-5.74,3.37-10.3,4s-8.67.23-11-1C199,90.14,202.86,88.57,207.41,87.91Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.8,99.09c4.55-.66,8.67-.23,11,1-1.92,1.8-5.74,3.38-10.3,4s-8.67.23-11-1C191.42,101.33,195.25,99.75,199.8,99.09Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.72,108.79c3.87-2.47,7.8-3.78,10.42-3.66-1,2.42-3.84,5.43-7.72,7.91s-7.8,3.78-10.42,3.66C184,114.28,186.84,111.27,190.72,108.79Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.94,142.5h-.08a.41.41,0,0,1-.37-.46,96.21,96.21,0,0,1,28.78-59.22.42.42,0,1,1,.58.6,95.49,95.49,0,0,0-28.53,58.7A.41.41,0,0,1,176.94,142.5Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.36,79.66c2.92-.93,5.67-1.11,7.34-.59-1.06,1.39-3.4,2.85-6.32,3.79a13.54,13.54,0,0,1-7.34.59C208.1,82.06,210.44,80.6,213.36,79.66Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.37,72.15c4.26-3.89,8.67-6.55,11.67-7.26-1,2.93-4,7.08-8.27,11s-8.67,6.55-11.67,7.26C207.07,80.2,210.11,76.05,214.37,72.15Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.46,74.21c1.26-3.65,3.17-6.56,4.95-7.85.61,2.12.31,5.58-.95,9.23s-3.17,6.56-5,7.85C205.9,81.32,206.2,77.86,207.46,74.21Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.92,63c-3.17-3.74-5.2-7.78-5.59-10.69,2.57.59,6.07,3.07,9.24,6.8s5.2,7.78,5.59,10.69C166.59,69.18,163.09,66.7,159.92,63Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.53,77.32c-3.17-3.73-5.2-7.78-5.59-10.68,2.57.58,6.07,3.06,9.24,6.8s5.2,7.78,5.59,10.68C166.2,83.54,162.7,81.06,159.53,77.32Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.13,93.3c-2.54-3-4-6.4-4.13-9,2.28.24,5.24,2.08,7.78,5.08s4,6.41,4.14,9C165.64,98.15,162.68,96.31,160.13,93.3Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.51,108.94c-1.19-3.18-1.44-6.31-.84-8.34,1.71,1,3.52,3.36,4.7,6.54s1.44,6.31.84,8.33C165.5,114.53,163.69,112.12,162.51,108.94Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.34,58.68c3-3.88,6.42-6.53,9-7.23-.28,2.92-2.16,7.06-5.18,10.94s-6.43,6.54-9,7.24C169.43,66.71,171.31,62.57,174.34,58.68Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.78,72.57c3-3.89,6.42-6.53,9-7.24-.28,2.93-2.15,7.06-5.18,11s-6.43,6.53-9,7.23C168.88,80.59,170.75,76.45,173.78,72.57Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172,89c2.63-3.38,5.69-5.58,8.05-6-.09,2.68-1.62,6.38-4.25,9.76s-5.69,5.58-8.06,6C167.87,96.05,169.4,92.35,172,89Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.72,106c1.82-3.58,4.11-6.25,6-7.26.19,2.34-.69,5.91-2.51,9.49s-4.11,6.25-6,7.25C167,113.14,167.9,109.56,169.72,106Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.88,127.93h0a.46.46,0,0,1-.37-.52c2.24-24.29,3.5-49,3.73-73.4a.46.46,0,0,1,.43-.47A.46.46,0,0,1,170,54c-.23,24.45-1.49,49.17-3.73,73.49A.45.45,0,0,1,165.88,127.93Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.6,48.67c-2.62-3.09-4.3-6.43-4.62-8.84,2.13.48,5,2.53,7.64,5.62s4.3,6.43,4.62,8.84C167.11,53.8,164.22,51.75,161.6,48.67Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.32,45.65c2.48-3.19,5.27-5.36,7.36-5.94-.22,2.4-1.76,5.8-4.25,9s-5.27,5.36-7.36,5.93C169.3,52.23,170.84,48.84,173.32,45.65Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.65,39.78c.11-5.73,1.26-10.59,2.88-13,1.52,2.88,2.49,8,2.38,13.76s-1.25,10.59-2.87,13C167.51,50.66,166.55,45.51,166.65,39.78Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156,134.36a.42.42,0,0,1-.41-.34c-3.62-18.46-7.36-37.55-16.71-54.3a.43.43,0,0,1,.17-.58.42.42,0,0,1,.57.17c9.41,16.86,13.16,36,16.79,54.55a.42.42,0,0,1-.33.49Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.09,76c-3.8-2.59-6.54-5.69-7.47-8.14,2.62,0,6.51,1.39,10.31,4s6.55,5.7,7.47,8.15C136.78,80.06,132.89,78.64,129.09,76Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.31,87.66c-3.8-2.59-6.55-5.69-7.48-8.15,2.63,0,6.51,1.4,10.31,4s6.55,5.69,7.48,8.14C142,91.68,138.11,90.25,134.31,87.66Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.17,100c-3.21-2.19-5.53-4.8-6.31-6.88,2.21,0,5.49,1.18,8.7,3.37s5.54,4.81,6.32,6.88C146.66,103.35,143.38,102.14,140.17,100Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.38,113.81c-2.36-2.46-3.87-5.12-4.17-7,1.9.38,4.5,2,6.86,4.46s3.88,5.12,4.17,7C150.34,117.89,147.74,116.26,145.38,113.81Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.54,69.23c1.05-4.48,3-8.16,4.91-9.91,1,2.44,1.05,6.58,0,11.06s-3,8.16-4.91,9.9C138.56,77.85,138.49,73.71,139.54,69.23Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.28,81.35c.91-3.9,2.69-7.08,4.59-8.56,1,2.17,1.22,5.81.31,9.71s-2.7,7.08-4.59,8.56C143.55,88.89,143.36,85.25,144.28,81.35Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.38,93.66c1.57-3.69,3.88-6.51,6-7.64.65,2.31.2,5.93-1.37,9.62s-3.88,6.5-6,7.63C148.36,101,148.8,97.34,150.38,93.66Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.14,110.72c1.29-3,3.17-5.32,4.9-6.24.53,1.89.17,4.84-1.12,7.85s-3.16,5.31-4.89,6.24C151.5,116.68,151.86,113.73,153.14,110.72Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.31,126.12h-2.92v-.31a.69.69,0,0,0-.52-.72.64.64,0,0,0-.72.68v.35h-3.51l-10.76-10.86a5.54,5.54,0,0,0-3.95-1.7h-2.52a3,3,0,0,0-2.26,1S202,129.93,168.4,130.05s-28.94-15.62-28.94-15.62l-2.14.07-9.72-.13a16.09,16.09,0,0,0-4.68.61c-2.81.83-6.32,2.7-6.32,6.91v2.86a2.91,2.91,0,0,0,1,2.2l.76.67a.88.88,0,0,1-.2,1.44h0a2.81,2.81,0,0,0-1.63,2.66l.1,6.67a1.6,1.6,0,0,0,1,1.47.88.88,0,0,1,.16,1.49l-.53.38a1.78,1.78,0,0,0-.69,1.44v3.22a5.79,5.79,0,0,0,2.59,5l.09.05a11.74,11.74,0,0,0,6.12,1.68h10.86a1.88,1.88,0,0,1,2.35,0h15.15a1.3,1.3,0,0,1,1.93-.06l.06.06h47.8l.06.07a3,3,0,0,0,2.26,1.06h2.53a5.6,5.6,0,0,0,4.16-1.92l10-11.1h3.63v.24a.69.69,0,0,0,.52.72.64.64,0,0,0,.72-.68v-.28h3Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.49,127.68h-2.3v-.25a.58.58,0,0,0-.4-.6.52.52,0,0,0-.57.57v.28h-2.76l-8.47-9a4.25,4.25,0,0,0-3.1-1.41h-2a2.33,2.33,0,0,0-1.78.88l-67.64-.33a5.11,5.11,0,0,0-1.65.24l-4-.12a11.82,11.82,0,0,0-3.68.51c-2.21.69-5,2.24-5,5.72v2.37a2.51,2.51,0,0,0,.75,1.83l.6.55a.75.75,0,0,1-.16,1.19h0a2.33,2.33,0,0,0-1.28,2.2l.08,5.52a1.33,1.33,0,0,0,.81,1.23.75.75,0,0,1,.12,1.23l-.42.31a1.49,1.49,0,0,0-.54,1.19v2.68a4.85,4.85,0,0,0,2,4.1l.06,0a8.94,8.94,0,0,0,4.82,1.4h22.41a1.41,1.41,0,0,1,1.85,0h11.91a1,1,0,0,1,1.52-.06l0,.06H204.4l0,0a2.33,2.33,0,0,0,1.78.88h2a4.32,4.32,0,0,0,3.27-1.59l7.87-9.2h2.86v.21a.59.59,0,0,0,.4.6.52.52,0,0,0,.57-.57v-.24h2.36Z",
    style: {
      fill: "#6f4439"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211,118.69a4.25,4.25,0,0,0-3.1-1.41h-2a2.33,2.33,0,0,0-1.78.88l-67.64-.33a5.11,5.11,0,0,0-1.65.24l-4-.12a11.82,11.82,0,0,0-3.68.51,9,9,0,0,0-3,1.55,162.75,162.75,0,0,0,52.28,7.37c12.08-.27,24.55-2,34.79-8.45Z",
    style: {
      fill: "#ae7461"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.53,153.08s-.08-5.41-.08-12.09,0-12.09.08-12.09.07,5.41.07,12.09S153.57,153.08,153.53,153.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.31,153s-.07-8.69-.07-19.4,0-19.39.07-19.39.08,8.68.08,19.39S138.35,153,138.31,153Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.06,153.22s-.08-8.68-.08-19.39,0-19.4.08-19.4.08,8.69.08,19.4S136.1,153.22,136.06,153.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.87,153.08c-.05,0-.08-5.34-.08-11.93s0-11.94.08-11.94.07,5.34.07,11.94S155.91,153.08,155.87,153.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.58,131a.8.8,0,0,1,.08-.29,2.62,2.62,0,0,1,.41-.67,8.78,8.78,0,0,1,2-1.47c.81-.51,1.55-1,2.08-1.28a6.41,6.41,0,0,1,.89-.49,5.94,5.94,0,0,1-.83.59c-.53.35-1.26.82-2.07,1.33a10.09,10.09,0,0,0-2,1.41A3.62,3.62,0,0,0,116.58,131Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.11,141.82a2.6,2.6,0,0,1-.66-.18c-.4-.13-1-.34-1.54-.6a15.79,15.79,0,0,1-1.51-.72,3.18,3.18,0,0,1-.6-.36,2.43,2.43,0,0,1,.64.25l1.52.67,1.53.65A2.89,2.89,0,0,1,122.11,141.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.32,153.06s-.08-8.59-.08-19.18,0-19.18.08-19.18.08,8.59.08,19.18S203.36,153.06,203.32,153.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.46,141.23s-.09-3.38-.11-7.56,0-7.55,0-7.55.09,3.38.11,7.55S227.5,141.23,227.46,141.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.15,141.62s-.08-3.47-.08-7.74,0-7.73.08-7.73.08,3.46.08,7.73S226.19,141.62,226.15,141.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.09,141.19c-.05,0-.08-3.37-.08-7.52s0-7.52.08-7.52.07,3.37.07,7.52S225.13,141.19,225.09,141.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224,141.19s-.07-3.37-.07-7.52,0-7.52.07-7.52.08,3.37.08,7.52S224.07,141.19,224,141.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.12,126.15a1.74,1.74,0,0,0-.69,1.07,5.45,5.45,0,0,0-.14,1.34,98.54,98.54,0,0,0,.41,11.78c0,.31.11.7.39.78,0-.63,0-1.26,0-1.9,0-3.75,0-7.5,0-11.25v-2.06",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.32,123.54h10.16s2.06-.12,2.06,10.27c0,9.44-2.37,9.42-2.37,9.42h-9.85Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.33,124.82s1.75-.09,3.92-.09,3.91,0,3.91.09-1.75.09-3.91.09S230.33,124.87,230.33,124.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.33,126.58s1.85-.09,4.13-.09,4.13,0,4.13.09-1.85.08-4.13.08S230.33,126.63,230.33,126.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.33,128.27c0-.05,1.92-.08,4.29-.08s4.28,0,4.28.08-1.92.09-4.28.09S230.33,128.32,230.33,128.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.33,130c0-.05,2-.09,4.39-.09s4.39,0,4.39.09-2,.08-4.39.08S230.33,130,230.33,130Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.33,131.66s2-.09,4.39-.09,4.39,0,4.39.09-2,.09-4.39.09S230.33,131.71,230.33,131.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.33,133.36c0-.05,2-.09,4.39-.09s4.39,0,4.39.09-2,.08-4.39.08S230.33,133.4,230.33,133.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.33,135.05c0-.05,2-.09,4.39-.09s4.39,0,4.39.09-2,.09-4.39.09S230.33,135.1,230.33,135.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.33,136.74s2-.08,4.39-.08,4.39,0,4.39.08-2,.09-4.39.09S230.33,136.79,230.33,136.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.33,138.44c0-.05,1.9-.09,4.24-.09s4.23,0,4.23.09-1.89.08-4.23.08S230.33,138.49,230.33,138.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.33,140.13s1.82-.08,4.06-.08,4.06,0,4.06.08-1.81.09-4.06.09S230.33,140.18,230.33,140.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.33,141.83c0-.05,1.72-.09,3.84-.09s3.83,0,3.83.09-1.71.08-3.83.08S230.33,141.87,230.33,141.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.79,142.52a.67.67,0,0,1,0-.19l.14-.53c.07-.23.15-.51.23-.84s.18-.69.26-1.11.19-.88.27-1.37.15-1,.23-1.59a34.38,34.38,0,0,0,.23-3.67,34.89,34.89,0,0,0-.19-3.68c-.07-.56-.13-1.1-.22-1.59s-.16-1-.25-1.37-.18-.8-.25-1.13-.15-.61-.22-.84l-.14-.53a1.52,1.52,0,0,1,0-.19.62.62,0,0,1,.07.18c.05.14.1.31.17.52s.16.51.24.84.19.7.27,1.12.2.87.28,1.37.15,1,.23,1.6a35,35,0,0,1,.21,3.7,34.55,34.55,0,0,1-.25,3.69c-.08.56-.15,1.1-.25,1.59s-.19,1-.29,1.38-.19.79-.28,1.11-.17.61-.25.83l-.17.52A1.52,1.52,0,0,1,237.79,142.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.31,142.63c-.05,0-.08-4.11-.08-9.17s0-9.17.08-9.17.07,4.11.07,9.17S230.35,142.63,230.31,142.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.31,126.12s0,.31,0,1,0,1.62,0,2.88c0,2.57.07,6.34.12,11.23v.11h-3.11l.12-.12a1.45,1.45,0,0,1-.08.66.76.76,0,0,1-.6.44.71.71,0,0,1-.67-.37,1.31,1.31,0,0,1-.14-.73l.13.13h-3.63l.11-.05-7.63,8.5-2.13,2.37a6.28,6.28,0,0,1-2.73,1.94,5.86,5.86,0,0,1-1.72.3h-2.6a2.85,2.85,0,0,1-.92-.14,3.41,3.41,0,0,1-1.54-1l.14.06-47.8.06h-.11l-.06-.07a1.07,1.07,0,0,0-1.64,0l-.07.08H138.47l-.07-.06a1.62,1.62,0,0,0-2,0l-.07.06h-8.82a23.51,23.51,0,0,1-4.49-.22,11.75,11.75,0,0,1-4.25-1.73,6,6,0,0,1-2.37-4,16.71,16.71,0,0,1-.08-2.33v-1.15a6.35,6.35,0,0,1,0-1.21,2,2,0,0,1,.65-1.12c.32-.27.72-.45.8-.67a.65.65,0,0,0-.15-.75c-.06-.06-.29-.13-.48-.27a2,2,0,0,1-.49-.46,2,2,0,0,1-.35-1.25V137l0-2.35,0-2.66a3.34,3.34,0,0,1,.92-2.63,2.77,2.77,0,0,1,.58-.44c.09-.06.24-.11.31-.15a.4.4,0,0,0,.16-.13.65.65,0,0,0-.06-.85c-.33-.3-.65-.55-1-.9a3.18,3.18,0,0,1-.68-1.25,4.65,4.65,0,0,1-.13-1.37V123a12,12,0,0,1,.17-2.65,6.7,6.7,0,0,1,3.13-4.19,13.75,13.75,0,0,1,4.86-1.8,25.55,25.55,0,0,1,5.08-.21l5,.07,2.46,0c.81,0,1.63,0,2.43-.07h.33l-.08.33a9,9,0,0,0,.61,5.54,10.87,10.87,0,0,0,3.53,4.3c3,2.28,6.62,3.38,10.12,4.19a49.23,49.23,0,0,0,5.32.81c1.76.17,3.51.37,5.24.37,3.47.17,6.85,0,10.13-.11,6.54-.42,12.72-1.59,17.94-4a17.81,17.81,0,0,0,1.91-.94l1.79-1.07c.56-.4,1.09-.82,1.63-1.22a19.12,19.12,0,0,0,1.48-1.35A12.22,12.22,0,0,0,203,114.6v-.06l0,0a3.26,3.26,0,0,1,1.81-1.05,17.08,17.08,0,0,1,2-.06,15.41,15.41,0,0,1,1.92.07,5.67,5.67,0,0,1,1.78.6,11.75,11.75,0,0,1,2.65,2.32l2.28,2.3,7.24,7.37-.06,0,3.51,0-.06.07a1.13,1.13,0,0,1,.23-.91.63.63,0,0,1,.74-.12,1,1,0,0,1,.38,1l-.05-.05,2.21,0c.48,0,.71,0,.71,0l-.74,0-2.18,0h0v0c0-.31,0-.71-.34-.93a.52.52,0,0,0-.6.11c-.19.18-.19.47-.18.82v.06h-.07l-3.51,0h0l0,0-7.3-7.3-2.29-2.3a11.44,11.44,0,0,0-2.6-2.24,5.36,5.36,0,0,0-1.69-.57,14.36,14.36,0,0,0-1.87-.05,13.83,13.83,0,0,0-1.94.06,2.94,2.94,0,0,0-1.62,1l0-.09a12.54,12.54,0,0,1-3.66,6.67,17.9,17.9,0,0,1-1.5,1.38c-.54.41-1.09.84-1.65,1.25L194.68,125a20.4,20.4,0,0,1-1.93,1c-5.28,2.44-11.5,3.63-18.07,4.06-3.3.16-6.69.3-10.17.14-1.75,0-3.5-.2-5.28-.37a48.07,48.07,0,0,1-5.37-.81c-3.54-.81-7.23-1.91-10.32-4.27a11.2,11.2,0,0,1-3.68-4.48l-.3-.68c-.09-.23-.13-.48-.2-.72l-.2-.72-.09-.75a8.34,8.34,0,0,1,.15-3l.25.32c-.81,0-1.63.07-2.45.07l-2.46,0-5-.07a24.35,24.35,0,0,0-5,.21,13.16,13.16,0,0,0-4.67,1.72,6.2,6.2,0,0,0-2.91,3.87,12.44,12.44,0,0,0-.15,2.54v1.31a4.09,4.09,0,0,0,.11,1.23,2.52,2.52,0,0,0,.57,1c.26.27.64.57,1,.86a1.13,1.13,0,0,1-.22,1.84c-.13.07-.19.08-.29.14a2,2,0,0,0-.47.35,2.82,2.82,0,0,0-.76,2.25c0,.89,0,1.77,0,2.67l0,2.34v1.17a1.47,1.47,0,0,0,.25.95,1.46,1.46,0,0,0,.36.34c.12.1.28.11.53.3a1.16,1.16,0,0,1,.28,1.37,1.25,1.25,0,0,1-.48.51l-.45.33a1.5,1.5,0,0,0-.49.84,7.73,7.73,0,0,0,0,1.1v1.15a15.12,15.12,0,0,0,.07,2.25A5.44,5.44,0,0,0,119,151a11.27,11.27,0,0,0,4,1.64,22.88,22.88,0,0,0,4.39.22h8.73l-.16.06a2.13,2.13,0,0,1,2.67,0l-.16-.06h15.15l-.18.08a1.57,1.57,0,0,1,1.22-.54,1.64,1.64,0,0,1,1.13.53l-.18-.07,47.8,0h.09l0,.07a3,3,0,0,0,1.37.93,5.13,5.13,0,0,0,1.68.13,10.09,10.09,0,0,0,3.33-.27,5.91,5.91,0,0,0,2.59-1.83l2.14-2.36,7.67-8.47,0,0h3.83v.13a1,1,0,0,0,.1.6.46.46,0,0,0,.43.25.5.5,0,0,0,.39-.3,1.19,1.19,0,0,0,.07-.55v-.13h3.12l-.11.12V130c0-1.27,0-2.23,0-2.9S230.31,126.12,230.31,126.12Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--plant-2--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.36,379.22c1.1,2.32,1.34,5.37-.44,7.22-1.63,1.7-4.4,1.76-6.6.91a13.25,13.25,0,0,1-6.82-6.71c-.94-1.94-4.67-11.57-1.56-12.66,1.34-.47,3.34.93,4.41,1.55a60.4,60.4,0,0,1,5.72,3.6A16.6,16.6,0,0,1,61.36,379.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.67,376.58c1.16.17,11.67,7,15,14.62s.71,37,2.1,37.31,27.5,0,27.5,0S78.73,410.76,85,402.56s26.7-29.18,26.7-29.18l-4.53-4.18s-16.93,16-20.78,14.83,0-24,0-24l-11.9-1.67s5.47,19.49-1,21.91S50.32,365.7,50.32,365.7l-6,.27Z",
    style: {
      fill: "#ae7461"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.18,351.64c2.56-.2,5.5.67,6.59,3,1,2.13.06,4.74-1.52,6.49a13.33,13.33,0,0,1-8.71,4c-2.15.19-12.47.22-12.38-3.08,0-1.42,2.07-2.78,3-3.56a60.46,60.46,0,0,1,5.41-4.05A16.66,16.66,0,0,1,64.18,351.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.72,350.4c2.56-.19,5.5.67,6.58,3,1,2.13.07,4.74-1.51,6.49a13.28,13.28,0,0,1-8.71,4c-2.15.19-12.47.22-12.38-3.08,0-1.42,2.07-2.78,3-3.56a60.46,60.46,0,0,1,5.41-4A16.66,16.66,0,0,1,94.72,350.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.15,364.53c2.43.85,4.77,2.83,4.83,5.39.06,2.36-1.84,4.37-4,5.34a13.24,13.24,0,0,1-9.56.13c-2.05-.68-11.52-4.79-10.11-7.78.61-1.28,3-1.71,4.2-2a60,60,0,0,1,6.59-1.54A16.59,16.59,0,0,1,135.15,364.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.42,333c2.56-.19,5.5.68,6.59,3,1,2.13.06,4.74-1.52,6.49a13.24,13.24,0,0,1-8.71,4c-2.14.19-12.47.22-12.37-3.08,0-1.42,2.06-2.77,3-3.55a56.12,56.12,0,0,1,5.41-4.06A16.69,16.69,0,0,1,101.42,333Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.12,357.6c-2.56.26-5.51-.54-6.66-2.84-1.05-2.1-.18-4.73,1.36-6.52a13.25,13.25,0,0,1,8.61-4.17c2.14-.24,12.47-.53,12.45,2.77,0,1.43-2,2.83-2.95,3.63a56.5,56.5,0,0,1-5.31,4.19A16.56,16.56,0,0,1,63.12,357.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.64,329.26c.2-2.56,1.51-5.32,4-6,2.26-.66,4.69.67,6.17,2.5a13.2,13.2,0,0,1,2.57,9.21c-.14,2.16-1.7,12.36-4.94,11.76-1.4-.26-2.43-2.47-3-3.54a58,58,0,0,1-3.17-6A16.62,16.62,0,0,1,69.64,329.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.79,353.52c1.86-1.77,4.68-3,7-1.86,2.13,1,3.06,3.63,3,6a13.21,13.21,0,0,1-4.22,8.58c-1.54,1.52-9.5,8.09-11.52,5.48-.87-1.12-.16-3.46.09-4.67a57.22,57.22,0,0,1,1.61-6.57A16.67,16.67,0,0,1,107.79,353.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44,344.6c1-2.37,3.1-4.59,5.66-4.51,2.36.08,4.26,2.1,5.1,4.3a13.25,13.25,0,0,1-.42,9.55c-.81,2-5.46,11.22-8.36,9.64-1.25-.68-1.54-3.1-1.79-4.31A58.35,58.35,0,0,1,43,352.61,16.66,16.66,0,0,1,44,344.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.49,372.1c-2.53-.4-5.19-1.93-5.71-4.44-.48-2.3,1-4.63,3-6a13.25,13.25,0,0,1,9.39-1.85c2.13.31,12.19,2.66,11.33,5.85-.37,1.37-2.65,2.22-3.77,2.76a57.8,57.8,0,0,1-6.2,2.7A16.69,16.69,0,0,1,31.49,372.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.63,388.09c-2.12,1.44-5.1,2.15-7.2.68-1.93-1.35-2.42-4.08-1.92-6.38a13.23,13.23,0,0,1,5.58-7.77c1.77-1.24,10.7-6.41,12.26-3.5.68,1.25-.41,3.43-.85,4.59a59.84,59.84,0,0,1-2.67,6.21A16.7,16.7,0,0,1,39.63,388.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.06,364.65a19.69,19.69,0,0,1-4.26-5.4c-1.43-2.44-2.72-5.13-2.64-8s1.94-5.79,4.74-6.24A6.18,6.18,0,0,1,41.08,347,14.08,14.08,0,0,1,44,351.92a41.35,41.35,0,0,1,2,6.87c.39,1.9,1.31,5,.76,6.9C45.84,369.05,39.67,366,38.06,364.65Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.28,347.86c1.8-1.83,4.58-3.11,6.93-2.08,2.16,1,3.17,3.52,3.14,5.88a13.31,13.31,0,0,1-3.94,8.72c-1.49,1.56-9.24,8.39-11.34,5.84-.9-1.09-.27-3.45-.06-4.67a59.87,59.87,0,0,1,1.39-6.62A16.72,16.72,0,0,1,51.28,347.86Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.2,384.19a7.88,7.88,0,0,1-2.85,4.05,5.74,5.74,0,0,1-7-1.24,8.56,8.56,0,0,1-1.77-7.27,17.39,17.39,0,0,1,3.34-6.92c1.35-1.82,3.71-5.43,6.08-5.94,2-.44,2.46,1.61,2.8,3.17A24.71,24.71,0,0,1,48.2,384.19Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.4,361.56a7.92,7.92,0,0,1,4.7,1.57,5.74,5.74,0,0,1,.83,7.09A8.54,8.54,0,0,1,57.48,374a17.37,17.37,0,0,1-7.59-1.21c-2.13-.77-6.27-2-7.44-4.11-1-1.79.84-2.83,2.24-3.6A24.8,24.8,0,0,1,58.4,361.56Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.28,375.69c1.88,2.23,5.17,2.88,8,2.23a17.63,17.63,0,0,0,7.49-4.34,43.6,43.6,0,0,0,5.34-5.7,2.25,2.25,0,0,0,.66-1.81c-.23-.88-1.34-1.13-2.25-1.18-5.54-.27-10.92,1.25-16.28,2.41C23.32,368.16,21.31,372.18,24.28,375.69Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.74,340.82a19.61,19.61,0,0,1,2.18-6.52c1.26-2.54,2.8-5.08,5.21-6.57s5.91-1.55,7.82.55a6.19,6.19,0,0,1,1.21,5.4,14.16,14.16,0,0,1-2.53,5.13A41,41,0,0,1,88,344.28c-1.37,1.37-3.46,3.83-5.35,4.42C79.31,349.74,78.51,342.9,78.74,340.82Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100,341.55c2.52.5,5.11,2.13,5.54,4.66.39,2.32-1.21,4.58-3.2,5.84a13.25,13.25,0,0,1-9.45,1.48c-2.12-.39-12.08-3.13-11.1-6.28.42-1.36,2.73-2.13,3.87-2.62a59.47,59.47,0,0,1,6.3-2.45A16.64,16.64,0,0,1,100,341.55Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.81,335.76c-.83,2.8.43,5.91,2.53,7.93a17.53,17.53,0,0,0,7.73,3.88,43.72,43.72,0,0,0,7.7,1.35,2.25,2.25,0,0,0,1.87-.44c.61-.67.21-1.74-.25-2.52-2.81-4.79-7-8.46-10.93-12.31C67.59,330.83,63.12,331.36,61.81,335.76Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.22,362.76a19.63,19.63,0,0,1,4.62-5.09c2.17-1.82,4.6-3.54,7.41-3.93s6,.95,6.94,3.63a6.19,6.19,0,0,1-1.06,5.44,14.26,14.26,0,0,1-4.37,3.68,41.77,41.77,0,0,1-6.44,3.16c-1.81.7-4.7,2.12-6.67,1.9C108.18,371.16,110.18,364.57,111.22,362.76Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124,384.39c.68,2.47.38,5.52-1.69,7-1.91,1.39-4.64,1-6.66-.25a13.22,13.22,0,0,1-5.54-7.8c-.6-2.08-2.59-12.21.66-12.74,1.41-.23,3.12,1.5,4.07,2.3a60,60,0,0,1,5,4.54A16.66,16.66,0,0,1,124,384.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.15,384.73c-2.52.48-5.54-.05-6.88-2.24-1.24-2-.6-4.7.77-6.62A13.24,13.24,0,0,1,97.25,371c2.11-.44,12.37-1.63,12.65,1.66.12,1.42-1.74,3-2.62,3.88a58,58,0,0,1-4.91,4.63A16.58,16.58,0,0,1,95.15,384.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.31,372.25c2.1,1.47,3.83,4,3.2,6.49-.57,2.28-2.94,3.71-5.27,4.07a13.27,13.27,0,0,1-9.25-2.44c-1.79-1.21-9.81-7.71-7.65-10.21.93-1.07,3.35-.84,4.6-.84a58.52,58.52,0,0,1,6.75.28A16.62,16.62,0,0,1,130.31,372.25Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94,375.25a7.87,7.87,0,0,1-4.47-2.14,5.74,5.74,0,0,1,0-7.14,8.56,8.56,0,0,1,6.87-3,17.25,17.25,0,0,1,7.38,2.15c2,1,6,2.75,6.88,5,.75,1.9-1.19,2.69-2.67,3.29A24.72,24.72,0,0,1,94,375.25Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.31,350.24c-1.88,2.23-2,5.58-.86,8.27a17.52,17.52,0,0,0,5.52,6.67,43.18,43.18,0,0,0,6.51,4.31,2.18,2.18,0,0,0,1.89.35c.83-.37.9-1.5.79-2.41-.65-5.51-3-10.56-5.08-15.65C104.58,348.05,100.28,346.73,97.31,350.24Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.46,369.32c-.66,2.48-2.45,5-5,5.23-2.34.23-4.49-1.51-5.62-3.58a13.29,13.29,0,0,1-.85-9.53c.53-2.09,3.92-11.85,7-10.67,1.33.51,1.94,2.88,2.35,4a58.84,58.84,0,0,1,2,6.45A16.66,16.66,0,0,1,84.46,369.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.86,360a7.84,7.84,0,0,1,1,4.84,5.74,5.74,0,0,1-5.69,4.32,8.57,8.57,0,0,1-6.53-3.65,17.18,17.18,0,0,1-2.8-7.15c-.42-2.22-1.47-6.42-.24-8.5,1.05-1.76,2.86-.71,4.24.1A24.82,24.82,0,0,1,94.86,360Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.53,363a7.85,7.85,0,0,1-4.72,1.49A5.75,5.75,0,0,1,63,359.25a8.53,8.53,0,0,1,3-6.84,17.22,17.22,0,0,1,6.86-3.47c2.17-.62,6.24-2.06,8.43-1,1.85.88,1,2.79.3,4.23C79.53,356.52,76.7,360.43,72.53,363Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.15,376.58a19.51,19.51,0,0,1-1.12,6.79c-.83,2.7-1.94,5.46-4.09,7.32s-5.58,2.48-7.8.71a6.19,6.19,0,0,1-2.06-5.14,14.2,14.2,0,0,1,1.67-5.47,41.52,41.52,0,0,1,3.7-6.14c1.14-1.57,2.8-4.33,4.58-5.22C111.15,367.88,113,374.5,113.15,376.58Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46,367.83a10.37,10.37,0,0,1-1.52.64,11.27,11.27,0,0,0-3.22,2.2A10.84,10.84,0,0,0,39,373.85a12.68,12.68,0,0,1-.67,1.51,3.57,3.57,0,0,1,.33-1.65,9.48,9.48,0,0,1,5.68-5.58A3.64,3.64,0,0,1,46,367.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.6,357.15a7.91,7.91,0,0,1,.88,2.81c.18.9.36,2,.54,3.15.09.6.18,1.22.3,1.85a3.15,3.15,0,0,1-.09,2.15,2.49,2.49,0,0,1-1.87,1.13,5.5,5.5,0,0,1-2-.13,8.93,8.93,0,0,1-2.94-1.37,17.8,17.8,0,0,1-1.7-1.34c-.38-.34-.58-.55-.56-.58s.94.65,2.46,1.61a9.13,9.13,0,0,0,2.85,1.21,5,5,0,0,0,1.77.09,2,2,0,0,0,1.49-.87,2.78,2.78,0,0,0,0-1.81c-.11-.65-.2-1.27-.28-1.87-.15-1.14-.3-2.2-.43-3.15C45.87,358.23,45.54,357.17,45.6,357.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.11,361.71a20.64,20.64,0,0,0-5.73,1.88,20.5,20.5,0,0,0-4.64,3.87,4.36,4.36,0,0,1,1-1.54,12.26,12.26,0,0,1,3.4-2.78,12,12,0,0,1,4.17-1.41A4.45,4.45,0,0,1,57.11,361.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.72,373c-.16,0-.11-1.38-.61-3s-1.28-2.69-1.15-2.79a4.65,4.65,0,0,1,1.65,2.64A4.6,4.6,0,0,1,48.72,373Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.81,348.11a7,7,0,0,1,2.11-.29c.65,0,1.44-.05,2.3,0l1.37.06a2.52,2.52,0,0,1,1.52.48,1.3,1.3,0,0,1,.41.8,2.85,2.85,0,0,1,0,.78,10.93,10.93,0,0,1-.26,1.36,11.55,11.55,0,0,1-.8,2.18,5.39,5.39,0,0,1-1.18,1.79c-.07-.05.36-.74.84-1.93a14.66,14.66,0,0,0,.67-2.16c.09-.41.17-.85.23-1.3a1.26,1.26,0,0,0-.23-1.14,2.16,2.16,0,0,0-1.21-.35l-1.35-.09c-.85,0-1.63-.07-2.28-.08A10.83,10.83,0,0,1,74.81,348.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.65,342.62c0,.15-2.13,1-4.54,2.51s-4.11,3.11-4.22,3a13.05,13.05,0,0,1,4-3.44A13,13,0,0,1,90.65,342.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.37,353.05a27.79,27.79,0,0,0-3.3-2.7,25.29,25.29,0,0,0-3.91-1.68,6.94,6.94,0,0,1,4.18,1.24A7.08,7.08,0,0,1,89.37,353.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.19,348.17a7.44,7.44,0,0,1-2.55-6.87c.16,0,.14,1.69.86,3.59A34.93,34.93,0,0,0,81.19,348.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.56,375.1a6.71,6.71,0,0,1,.94-1l2.69-2.49a11.59,11.59,0,0,0,1.72-1.77,1.82,1.82,0,0,0,.34-1.19,2,2,0,0,0-.61-1.15,16.14,16.14,0,0,0-2.6-1.75A22.78,22.78,0,0,0,102,364.3a13.59,13.59,0,0,0-6.4-1,9.11,9.11,0,0,0-4.86,1.93,8,8,0,0,0-2.23,2.79c-.36.77-.46,1.24-.51,1.23s0-.12,0-.35a6.21,6.21,0,0,1,.29-1,7.68,7.68,0,0,1,2.18-3,9.3,9.3,0,0,1,5-2.13,13.71,13.71,0,0,1,6.63,1,21.14,21.14,0,0,1,3.13,1.53A15.12,15.12,0,0,1,108,367.2a2.36,2.36,0,0,1,.73,1.45,2.26,2.26,0,0,1-.44,1.46,10.75,10.75,0,0,1-1.84,1.81l-2.79,2.36A5.72,5.72,0,0,1,102.56,375.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.94,369.48a12.19,12.19,0,0,1-2.3-.35c-.7-.12-1.54-.26-2.47-.39a9.42,9.42,0,0,0-3-.13,1.33,1.33,0,0,0-1,.87,2.8,2.8,0,0,0,0,1.35,9.5,9.5,0,0,0,.8,2.3c.64,1.26,1.24,1.92,1.18,2a5,5,0,0,1-1.5-1.8,8.82,8.82,0,0,1-1-2.4,3.19,3.19,0,0,1,0-1.59,1.83,1.83,0,0,1,1.29-1.21,4.41,4.41,0,0,1,1.69-.05c.52.06,1,.13,1.48.21.94.15,1.78.33,2.48.5A8.63,8.63,0,0,1,119.94,369.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.6,369.66c-.1.11-.59-.22-1.26-.3s-1.22.08-1.29-.05.5-.59,1.36-.47S110.72,369.58,110.6,369.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.56,369.6a4.63,4.63,0,0,1,1.26-5.77,13.75,13.75,0,0,0-1.16,2.77A15.19,15.19,0,0,0,109.56,369.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107,353.84a9.53,9.53,0,0,0-1-2.33,5.75,5.75,0,0,0-2-1.81,5.56,5.56,0,0,0-6.17.64,5.72,5.72,0,0,0-1.57,2.18,9.58,9.58,0,0,0-.52,2.48s-.11-.24-.13-.7a5.46,5.46,0,0,1,.3-1.91,5.8,5.8,0,0,1,8.33-3.11,5.85,5.85,0,0,1,2,2,5.18,5.18,0,0,1,.69,1.82A1.37,1.37,0,0,1,107,353.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.81,410c-4.07-1.59-8.93-.5-12.56,1.69a16.52,16.52,0,0,0-7.5,10.06,17.77,17.77,0,0,0-.5,6.33,22.12,22.12,0,0,0,2.07,7.23,24,24,0,0,0,8.34,9.27,26.61,26.61,0,0,0,12.8,4.26,4.23,4.23,0,0,0,2.93-1.21,4.15,4.15,0,0,0,0-5.86,4.57,4.57,0,0,0-2.93-1.21c-.42,0-.85-.08-1.27-.13l1.1.15A23,23,0,0,1,47.58,439l1,.41a22.19,22.19,0,0,1-4.83-2.8l.84.65a20.47,20.47,0,0,1-3.73-3.71l.65.84a19.18,19.18,0,0,1-2.39-4.11l.41,1a16.48,16.48,0,0,1-1.11-4.07l.15,1.1a15.42,15.42,0,0,1,0-3.84l-.15,1.1a14.76,14.76,0,0,1,1-3.53L39,423a13.29,13.29,0,0,1,1.58-2.73l-.65.84A12,12,0,0,1,42,419.06l-.84.65a14.75,14.75,0,0,1,3-1.77l-1,.42a13,13,0,0,1,3.18-.9l-1.1.15a10.37,10.37,0,0,1,2.49,0l-1.1-.15a8.48,8.48,0,0,1,2,.51,4.14,4.14,0,0,0,4.67-6.08l-.64-.84A4.23,4.23,0,0,0,50.81,410Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106,410.43c-.4-3.74-4.71-6.25-4.71-6.25a18,18,0,0,0,0-3.05H52.39a18,18,0,0,0,0,3.05s-4.31,2.51-4.71,6.25c-.34,3.19-2.25,40-1.58,43.53s3.06,8.66,17,10H90.61c13.93-1.36,16.31-6.45,17-10S106.37,413.62,106,410.43Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.69,428.16s6.48-1,7.89-4.46.43-17.63,2.27-21.57a16.29,16.29,0,0,1,9.61-8.79v3.56l4.22,2.6s-6.15,1.76-6.69,7.92,1.85,21.61-2.69,28.38c-3.13,4.68-8.88,9.29-14.61,10.05,0,0-4.32-1.3-3.67-8.21S105.69,428.16,105.69,428.16Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.32,404c0,.14-10.8.26-24.11.26S53.1,404.16,53.1,404s10.79-.26,24.11-.26S101.32,403.87,101.32,404Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.55,409.29c0-.06.68,0,1.31.72a3.31,3.31,0,0,1,.66,1.53,8.11,8.11,0,0,1,0,2,7.2,7.2,0,0,1-.8,3.49,1.66,1.66,0,0,1-.93.65c-.27,0-.42,0-.42,0a2,2,0,0,0,1-.83,8.58,8.58,0,0,0,.59-3.32,5,5,0,0,0-.48-3.25C48.09,409.52,47.52,409.37,47.55,409.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.8,447.39a8.22,8.22,0,0,0,1.63-.72,4.36,4.36,0,0,0,1.86-3.58,5.94,5.94,0,0,0-1.45-3.89,3.6,3.6,0,0,0-1.47-.93c0-.07.83-.18,1.73.67a5.79,5.79,0,0,1,1.71,4.16,4.68,4.68,0,0,1-.7,2.44A4.4,4.4,0,0,1,47.62,447,2.42,2.42,0,0,1,45.8,447.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.2,445.45a2.33,2.33,0,0,1-.81-.3,9.15,9.15,0,0,1-2-1.32A10.32,10.32,0,0,1,103,429.6a9.36,9.36,0,0,1,1.67-1.68,2.34,2.34,0,0,1,.73-.45,22.09,22.09,0,0,0-2.1,2.35,10.35,10.35,0,0,0,1.34,13.73A20.69,20.69,0,0,0,107.2,445.45Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--plant-1--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M95.7,214.22l-49.46-.3L46,233.83a11.78,11.78,0,0,0,.36,3l-.17,14a25.12,25.12,0,0,0,.79,6.74c1.05,4,3.44,9.09,8.82,9.09h3.66a3.55,3.55,0,0,0,2.81-1.38l.85-1.09a1.06,1.06,0,0,1,1.84.29,3.57,3.57,0,0,0,3.4,2.33l8.53-.13a2.08,2.08,0,0,0,1.88-1.48,1.06,1.06,0,0,1,1.9-.22l.49.75a2.16,2.16,0,0,0,1.84,1h4.12A7.2,7.2,0,0,0,93.48,263a.75.75,0,0,1,.07-.12,18.64,18.64,0,0,0,2.15-8.82V238.44a3,3,0,0,1,0-3.38Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.7,214.22s0,.11,0,.34,0,.59,0,1c0,.95,0,2.3,0,4.06,0,3.59,0,8.81.09,15.41v.05l0,0a2.81,2.81,0,0,0,0,3.2l0,0v.05c0,4.5,0,9.56,0,15.1a19.47,19.47,0,0,1-1.7,8.52,8.13,8.13,0,0,1-2.88,3.63A7.71,7.71,0,0,1,86.72,267H83.07a2.5,2.5,0,0,1-1.3-.34,2.75,2.75,0,0,1-.92-1l-.34-.52a.85.85,0,0,0-.35-.33.86.86,0,0,0-.91.13,1.09,1.09,0,0,0-.26.44,2.4,2.4,0,0,1-.33.61,2.32,2.32,0,0,1-1.13.84,5.34,5.34,0,0,1-1.34.11l-2.59,0-5.25.08a3.85,3.85,0,0,1-2.61-1,4,4,0,0,1-.85-1.15c0-.11-.09-.22-.14-.34a.94.94,0,0,0-.12-.22.92.92,0,0,0-.42-.28.84.84,0,0,0-.92.37l-.84,1.08a3.8,3.8,0,0,1-2.51,1.38c-1,.05-1.86,0-2.8,0a14.36,14.36,0,0,1-2.83-.16,7.86,7.86,0,0,1-4.79-3.06,17.76,17.76,0,0,1-2.88-6.53,26.37,26.37,0,0,1-.67-6.94c.06-4.58.12-9,.17-13.38v.06a11.91,11.91,0,0,1-.37-3.08l0-3c0-2,0-3.94.07-5.85q.07-5.76.14-11.07v-.23h.22l35.93.34,10,.12,2.63,0,.66,0H82l-35.79-.11.23-.22c0,3.54-.07,7.24-.11,11.07q0,2.88-.06,5.85c0,2-.21,4,.33,5.94v.07c0,4.34-.1,8.81-.16,13.38a25.78,25.78,0,0,0,.67,6.82,16.91,16.91,0,0,0,2.79,6.33,7.28,7.28,0,0,0,4.47,2.87,13.69,13.69,0,0,0,2.73.15c.91,0,1.88,0,2.74,0a3.32,3.32,0,0,0,2.17-1.2l.84-1.07a1.33,1.33,0,0,1,1.45-.54A1.29,1.29,0,0,1,65,264a1.33,1.33,0,0,1,.2.37c0,.09.08.19.13.29a3.39,3.39,0,0,0,.73,1,3.33,3.33,0,0,0,2.25.89l5.25-.08,2.59,0a4.51,4.51,0,0,0,1.2-.09,1.72,1.72,0,0,0,.88-.65,2.19,2.19,0,0,0,.27-.5,1.53,1.53,0,0,1,.4-.62,1.31,1.31,0,0,1,1.44-.21,1.34,1.34,0,0,1,.55.5l.34.53a2.21,2.21,0,0,0,.76.81,2,2,0,0,0,1,.28h3.65a7.29,7.29,0,0,0,4.35-1.19,7.62,7.62,0,0,0,2.73-3.44,19,19,0,0,0,1.69-8.33c0-5.54,0-10.6,0-15.1l0,.1a3.13,3.13,0,0,1,0-3.57l0,.09c0-6.56.07-11.74.09-15.32,0-1.77,0-3.14,0-4.09,0-.45,0-.8,0-1.06A2.89,2.89,0,0,1,95.7,214.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.48,266.69a.92.92,0,0,1-.37-.11,2.87,2.87,0,0,1-.86-.6,13.07,13.07,0,0,1-1.88-2.87c-.65-1.17-1.23-2.23-1.64-3a8.22,8.22,0,0,1-.62-1.28,10.28,10.28,0,0,1,.76,1.2c.44.75,1,1.8,1.69,3a15,15,0,0,0,1.8,2.87A4.44,4.44,0,0,0,67.48,266.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.3,258.72a3.69,3.69,0,0,1-.22.95c-.18.58-.44,1.37-.77,2.23s-.66,1.62-.92,2.17a4.12,4.12,0,0,1-.47.86,4,4,0,0,1,.33-.93l.86-2.18.82-2.19A6,6,0,0,1,81.3,258.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84,178.46a2.65,2.65,0,0,1-.15.55l-.51,1.54c-.46,1.34-1.09,3.28-1.83,5.69s-1.57,5.31-2.4,8.54-1.62,6.81-2.34,10.6S75.46,212.79,75,216.1s-.7,6.31-.88,8.83-.31,4.55-.37,6c0,.68-.07,1.22-.09,1.63a2.18,2.18,0,0,1-.06.57,3.61,3.61,0,0,1,0-.57c0-.42,0-1,0-1.63,0-1.41.08-3.46.23-6s.42-5.53.8-8.85.94-7,1.65-10.76,1.55-7.38,2.38-10.61,1.7-6.13,2.49-8.53,1.45-4.34,2-5.66c.24-.63.43-1.14.58-1.52A3,3,0,0,1,84,178.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.69,173.14a4.86,4.86,0,0,0-3.93-2.8,9.9,9.9,0,0,0-4.93.85,7.51,7.51,0,0,0-3.57,2.54,5.65,5.65,0,0,0-.35,5.08,10.11,10.11,0,0,0,3.25,4.09,17.82,17.82,0,0,0,5.78-2.61,9.57,9.57,0,0,0,3.21-2.95A4.8,4.8,0,0,0,92.69,173.14Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.14,198.93a3.82,3.82,0,0,1,0-3.79,7.72,7.72,0,0,1,2.77-2.79,5.83,5.83,0,0,1,3.24-1.15,4.38,4.38,0,0,1,3.43,2.06,8,8,0,0,1,1.17,3.94,14.13,14.13,0,0,1-4.29,2.53,7.37,7.37,0,0,1-3.34.74A3.75,3.75,0,0,1,67.14,198.93Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.7,197.59a3.86,3.86,0,0,0,.54-3.8,7.91,7.91,0,0,0-2.41-3.18,6,6,0,0,0-3.1-1.59A4.48,4.48,0,0,0,83,190.63a8.05,8.05,0,0,0-1.7,3.81,14,14,0,0,0,4,3.12,7.41,7.41,0,0,0,3.25,1.19A3.81,3.81,0,0,0,91.7,197.59Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.32,178.14a4,4,0,0,0-3.85,1.64,6.38,6.38,0,0,0-.92,3.91,6.12,6.12,0,0,0,1.06,3.65A6.82,6.82,0,0,0,75,189.75a10,10,0,0,0,4.78-.6,13,13,0,0,0-.37-5.27,8.47,8.47,0,0,0-1.55-3.56A5.75,5.75,0,0,0,74.32,178.14Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.43,186a4,4,0,0,0-3.85,1.64,6.5,6.5,0,0,0-.92,3.91,6.22,6.22,0,0,0,1.06,3.64,6.84,6.84,0,0,0,4.44,2.42,10,10,0,0,0,4.78-.6,12.87,12.87,0,0,0-.38-5.27A8.33,8.33,0,0,0,51,188.14,5.77,5.77,0,0,0,47.43,186Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.78,193.51a2.75,2.75,0,0,1,.28.39l.72,1.13c.63,1,1.48,2.43,2.49,4.26s2.15,4,3.32,6.51,2.34,5.28,3.45,8.25,2,5.85,2.77,8.49,1.32,5,1.73,7.07.72,3.68.89,4.83c.08.54.14,1,.19,1.32a2.27,2.27,0,0,1,0,.46,2.84,2.84,0,0,1-.12-.45c-.06-.34-.15-.77-.25-1.31-.21-1.14-.55-2.78-1-4.8s-1.06-4.4-1.81-7-1.69-5.49-2.79-8.46-2.28-5.73-3.41-8.23S55,201.24,54,199.4s-1.8-3.3-2.39-4.3L51,193.93A2.1,2.1,0,0,1,50.78,193.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.58,211.3a3.8,3.8,0,0,1,0-3.79,7.72,7.72,0,0,1,2.77-2.79,5.8,5.8,0,0,1,3.24-1.15A4.38,4.38,0,0,1,56,205.63a8.06,8.06,0,0,1,1.17,3.94,14.16,14.16,0,0,1-4.29,2.54,7.38,7.38,0,0,1-3.34.73A3.75,3.75,0,0,1,46.58,211.3Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.07,191.73a3.53,3.53,0,0,0-2.31-2.93,4.65,4.65,0,0,0-3.28.54A5.52,5.52,0,0,0,56,191.59a7.82,7.82,0,0,0-.66,4.89,10.15,10.15,0,0,0,1.77,4.15,10.32,10.32,0,0,0,4-2.21,7.81,7.81,0,0,0,2.33-2.66A6.58,6.58,0,0,0,64.07,191.73Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.5,194.12a13.27,13.27,0,0,1-.11,2,41.63,41.63,0,0,0-.08,4.9,31.13,31.13,0,0,0,.61,4.86,15.05,15.05,0,0,1,.39,2,8,8,0,0,1-.68-1.93,23.85,23.85,0,0,1-.73-4.91,28.29,28.29,0,0,1,.2-5A8,8,0,0,1,57.5,194.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.23,214.73a34,34,0,0,0-2.2-3,11.48,11.48,0,0,0-1.93-1.71c-.55-.39-.94-.53-.92-.59s.46,0,1.07.34a8.29,8.29,0,0,1,2.09,1.68A7,7,0,0,1,61.23,214.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.65,198.24a4,4,0,0,1,3.85,1.64c1.9,2.73,1,.89.92,3.91a6.22,6.22,0,0,1-1.06,3.64,6.84,6.84,0,0,1-4.44,2.42,10.15,10.15,0,0,1-4.78-.6,12.87,12.87,0,0,1,.38-5.27,8.33,8.33,0,0,1,1.54-3.56A5.77,5.77,0,0,1,94.65,198.24Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.3,205.79a3,3,0,0,0-.28.38l-.72,1.14c-.63,1-1.48,2.43-2.49,4.26s-2.14,4-3.32,6.51-2.34,5.28-3.45,8.25-2,5.85-2.77,8.49-1.32,5-1.73,7.07-.72,3.68-.89,4.83c-.08.54-.14,1-.19,1.32a2.27,2.27,0,0,0,0,.46,3.34,3.34,0,0,0,.12-.45c.06-.34.15-.77.25-1.31.21-1.14.55-2.78,1-4.8s1.06-4.4,1.81-7,1.69-5.49,2.79-8.46,2.28-5.74,3.41-8.23,2.26-4.71,3.24-6.54,1.8-3.3,2.39-4.3l.66-1.17A2.1,2.1,0,0,0,91.3,205.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93,231.9l-43.46.22a22.16,22.16,0,0,0,.31,3.83l-.15,11.41a20.08,20.08,0,0,0,.68,5.5c.91,3.29,3,7.41,7.59,7.41H61.1a3.11,3.11,0,0,0,2.42-1.12l.73-.89a.93.93,0,0,1,1.58.23,3.08,3.08,0,0,0,2.93,1.91l7.33-.11a1.76,1.76,0,0,0,1.62-1.21.93.93,0,0,1,1.63-.18l.42.62a1.94,1.94,0,0,0,1.58.81h3.55a6.26,6.26,0,0,0,5.45-3l.06-.1A14.67,14.67,0,0,0,92.25,250V237.25C92.5,236.17,93,231.9,93,231.9Z",
    style: {
      fill: "#6f4439"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.44,204a3.55,3.55,0,0,1,2.32-2.93,4.6,4.6,0,0,1,3.28.54,5.46,5.46,0,0,1,2.53,2.25,7.82,7.82,0,0,1,.66,4.89,10,10,0,0,1-1.77,4.14,10.16,10.16,0,0,1-4-2.2A7.94,7.94,0,0,1,79.15,208,6.74,6.74,0,0,1,78.44,204Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.58,206.4a13.27,13.27,0,0,0,.11,2,41.63,41.63,0,0,1,.08,4.9,32.73,32.73,0,0,1-.6,4.86,16.44,16.44,0,0,0-.4,2,8,8,0,0,0,.68-1.93,23.85,23.85,0,0,0,.73-4.91,27.3,27.3,0,0,0-.2-5A7.89,7.89,0,0,0,84.58,206.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.67,209.16a3.81,3.81,0,0,0-1.39-3.52,7.65,7.65,0,0,0-3.61-1.55,5.83,5.83,0,0,0-3.44.14,4.44,4.44,0,0,0-2.41,3.2,8.05,8.05,0,0,0,.39,4.09,14.09,14.09,0,0,0,4.93.75,7.5,7.5,0,0,0,3.38-.57A3.77,3.77,0,0,0,74.67,209.16Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.93,217.83c.13,0,.2-1.67.93-3.57A11.09,11.09,0,0,1,64,211.94c.36-.56.67-.83.63-.88s-.42.17-.86.71a8.25,8.25,0,0,0-1.31,2.34A7,7,0,0,0,61.93,217.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.92,196.79a8.38,8.38,0,0,1,.32,5.7c-.12,0,0-1.29-.07-2.85S76.8,196.83,76.92,196.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.77,193.11A13.38,13.38,0,0,1,80,196,12.83,12.83,0,0,1,78,198.57a14.26,14.26,0,0,1,1.74-2.85A13.42,13.42,0,0,1,81.77,193.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.21,192.82a14.53,14.53,0,0,1,.24-4.92,14.53,14.53,0,0,1-.24,4.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93,231.9c0,1-9.73,1.86-21.73,1.86s-21.73-.83-21.73-1.86,9.34-5.54,21.34-5.54S93,230.88,93,231.9Z",
    style: {
      fill: "#ae7461"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.7,235.06a2.2,2.2,0,0,1-.47.22c-.32.12-.78.3-1.39.51-1.22.43-3,1-5.22,1.56a73.87,73.87,0,0,1-17.81,2.24,84.56,84.56,0,0,1-17.89-1.46,33.49,33.49,0,0,1-5.24-1.51,4.6,4.6,0,0,1-1.75-1s.15.1.46.24.76.33,1.36.54A37.76,37.76,0,0,0,53,237.76a91.82,91.82,0,0,0,17.82,1.31A79.87,79.87,0,0,0,88.53,237c2.23-.52,4-1,5.25-1.39l1.41-.42A2.94,2.94,0,0,1,95.7,235.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.7,213.88s-.06-.17-.15-.51-.24-.84-.41-1.48l-1.55-5.71c-1.33-5-3.26-12.19-5.66-21.19-4.78-18-11.46-43.16-19.07-71.84h.49c-1.81,7.94-3.69,16.18-5.62,24.61-6.65,29-12.78,55.77-17.6,76.77l-.05-.19a11,11,0,0,0,2.53,1.12c.89.28,1.79.54,2.68.75a52,52,0,0,0,5.29,1,88.28,88.28,0,0,0,9.87.77,87.23,87.23,0,0,0,15.92-.84,77,77,0,0,0,9.91-2.19l2.54-.77.88-.27-.84.32c-.58.21-1.42.49-2.54.84a71.71,71.71,0,0,1-9.92,2.3,86.54,86.54,0,0,1-16,.95,89,89,0,0,1-9.91-.74,50.44,50.44,0,0,1-5.33-1c-.9-.21-1.81-.46-2.72-.75-.45-.16-.9-.31-1.35-.5a5.8,5.8,0,0,1-1.34-.71l-.09-.06,0-.13c4.79-21,10.88-47.76,17.5-76.8C65.15,129.2,67,121,68.85,113l.24-1,.26,1c7.55,28.77,14.16,54,18.9,72.06,2.34,9,4.21,16.2,5.51,21.17.63,2.46,1.12,4.37,1.46,5.68.16.63.28,1.12.37,1.46S95.7,213.88,95.7,213.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.7,237.63a2.63,2.63,0,0,1-.47.21c-.32.12-.78.31-1.39.51-1.22.43-3,1-5.22,1.56a73.87,73.87,0,0,1-17.81,2.24,84.56,84.56,0,0,1-17.89-1.46,32.43,32.43,0,0,1-5.24-1.51,4.87,4.87,0,0,1-1.75-1,5,5,0,0,1,.46.23,12.69,12.69,0,0,0,1.36.54A39,39,0,0,0,53,240.33a92.72,92.72,0,0,0,17.82,1.3,79.28,79.28,0,0,0,17.72-2.08c2.23-.52,4-1,5.25-1.39l1.41-.42A1.75,1.75,0,0,1,95.7,237.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.69,114.22a3.41,3.41,0,1,1-3.41-3.41A3.41,3.41,0,0,1,72.69,114.22Z",
    style: {
      fill: "#263238"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartError);
export default __webpack_public_path__ + "static/media/cart-error.afeec84d354a2bdf39af76dbe9e89577.svg";
export { ForwardRef as ReactComponent };